export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
  Timestamp: { input: any; output: any; }
};

/** Category of address */
export enum Address_Category {
  Friend = 'FRIEND',
  Home = 'HOME',
  Other = 'OTHER',
  Work = 'WORK'
}

export type AcceptInvitationResponse = {
  __typename?: 'AcceptInvitationResponse';
  storeId?: Maybe<Scalars['Float']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ActiveFulfillmentFilterInput = {
  fleet?: InputMaybe<DeliveryFleet>;
  /** Mapped status. Mr Mandoob new matches pending, picked matches accepted, arrived_to_store matches arrived_to_restaurant. */
  requestStatus?: InputMaybe<DriverOrderRequestStatus>;
};

export type AddMrMandoobOrderDto = {
  customer: MrMandoobCustomerDto;
  fromAddress: Scalars['String']['input'];
  fromLat: Scalars['Float']['input'];
  fromLong: Scalars['Float']['input'];
  fromName: Scalars['String']['input'];
  merchantOrderId?: InputMaybe<Scalars['String']['input']>;
  toAddress: Scalars['String']['input'];
  toLat: Scalars['Float']['input'];
  toLong: Scalars['Float']['input'];
  vehicleType?: InputMaybe<MrMandoobVehicleType>;
};

export type Address = {
  __typename?: 'Address';
  active: Scalars['Boolean']['output'];
  addressCategory?: Maybe<Scalars['String']['output']>;
  addressCategoryLabel?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  details?: Maybe<Scalars['String']['output']>;
  fullAddress: Scalars['String']['output'];
  fullAddressAr: Scalars['String']['output'];
  id: Scalars['Float']['output'];
  isTemp?: Maybe<Scalars['Boolean']['output']>;
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  nameAr: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type AddressWithDeliveryArea = {
  __typename?: 'AddressWithDeliveryArea';
  active: Scalars['Boolean']['output'];
  addressCategory?: Maybe<Scalars['String']['output']>;
  addressCategoryLabel?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  details?: Maybe<Scalars['String']['output']>;
  fullAddress: Scalars['String']['output'];
  fullAddressAr: Scalars['String']['output'];
  id: Scalars['Float']['output'];
  isOutOfDeliveryArea: Scalars['Boolean']['output'];
  isTemp?: Maybe<Scalars['Boolean']['output']>;
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  nameAr: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type AdminNearbyDriverDto = {
  __typename?: 'AdminNearbyDriverDto';
  distanceKm: Scalars['Float']['output'];
  driverId: Scalars['Int']['output'];
  driverStatus?: Maybe<DriverStatus>;
  hasUncompletedDeliveryRequest: Scalars['Boolean']['output'];
  isOnline: Scalars['Boolean']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  vehicleNumber?: Maybe<Scalars['String']['output']>;
  vehicleType?: Maybe<Scalars['String']['output']>;
};

export type AdminOrderViewDto = {
  __typename?: 'AdminOrderViewDto';
  nearbyDrivers: Array<AdminNearbyDriverDto>;
  order: OrderWithGroupedItems;
};

export type AdminPurgeDriverByPhoneResult = {
  __typename?: 'AdminPurgeDriverByPhoneResult';
  deletedAddresses: Scalars['Int']['output'];
  deletedBeneficiaries: Scalars['Int']['output'];
  deletedDeviceTokens: Scalars['Int']['output'];
  deletedDriverIdentity: Scalars['Int']['output'];
  deletedDriverInfo: Scalars['Int']['output'];
  deletedDriverLicenses: Scalars['Int']['output'];
  deletedDriverOrderRequests: Scalars['Int']['output'];
  deletedDriverProfilePictures: Scalars['Int']['output'];
  deletedDriverTransactions: Scalars['Int']['output'];
  deletedDriverVehicleRegistrations: Scalars['Int']['output'];
  deletedDriverWithdrawals: Scalars['Int']['output'];
  deletedIntegrationLogs: Scalars['Int']['output'];
  deletedNafathVerifications: Scalars['Int']['output'];
  deletedRefreshTokens: Scalars['Int']['output'];
  deletedUserPermissionLinks: Scalars['Int']['output'];
  deletedUserSavedCards: Scalars['Int']['output'];
  deletedUsers: Scalars['Int']['output'];
  /** Deleted driver user id. */
  driverId: Scalars['Int']['output'];
  /** Phone number that was matched. */
  phoneNumber: Scalars['String']['output'];
  /** True when a Tawseel deactivateDriver job was enqueued for this driver. */
  tawseelDeactivated: Scalars['Boolean']['output'];
  unassignedOrders: Scalars['Int']['output'];
};

export type AdminRunLogisticsFlowResult = {
  __typename?: 'AdminRunLogisticsFlowResult';
  /** Dummy car number used (1234ABC). */
  carNumber?: Maybe<Scalars['String']['output']>;
  /** Driver user id used for the flow. */
  driverId: Scalars['Int']['output'];
  /** Dummy driver idNumber used (e.g. iqama). */
  driverIdNumber?: Maybe<Scalars['String']['output']>;
  /** Dummy driver phone used (local Saudi format 05XXXXXXXX). */
  driverPhoneNumber?: Maybe<Scalars['String']['output']>;
  /** Created order id. */
  orderId?: Maybe<Scalars['Int']['output']>;
  /** Created shopping session id. */
  shoppingSessionId?: Maybe<Scalars['Int']['output']>;
  /** Per-step outcomes. */
  steps: Array<AdminRunLogisticsFlowStep>;
  /** True when the full flow reached DELIVERED without errors. */
  success: Scalars['Boolean']['output'];
  /** Dummy vehicle sequence number used (9 digits). */
  vehicleSequenceNumber?: Maybe<Scalars['String']['output']>;
};

export type AdminRunLogisticsFlowStep = {
  __typename?: 'AdminRunLogisticsFlowStep';
  /** Optional message (success info or error message). */
  message?: Maybe<Scalars['String']['output']>;
  /** Step name (for debugging). */
  name: Scalars['String']['output'];
  /** Order status after the step (if applicable). */
  orderStatus?: Maybe<OrderStatus>;
  /** Whether this step succeeded. */
  success: Scalars['Boolean']['output'];
};

export type AdminSeedNearbyFlashSalesResult = {
  __typename?: 'AdminSeedNearbyFlashSalesResult';
  /** Number of flash-sale sessions successfully created. */
  createdCount: Scalars['Int']['output'];
  /** Per-store errors when a seed attempt failed (partial success). */
  errors?: Maybe<Array<Scalars['String']['output']>>;
  /** IDs of created shopping sessions (flash sales). */
  shoppingSessionIds: Array<Scalars['Int']['output']>;
};

export type AdminUnassignedOrdersFilterInput = {
  createdAfter?: InputMaybe<Scalars['DateTime']['input']>;
  createdBefore?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  orderType?: InputMaybe<ShoppingSessionType>;
  storeId?: InputMaybe<Scalars['Int']['input']>;
};

export type AllPartnersBalanceResponse = {
  __typename?: 'AllPartnersBalanceResponse';
  /** Grand total balance across all partners */
  grandTotal: Scalars['String']['output'];
  /** Balance data for all partners */
  partners: Array<PartnerBalance>;
};

export type AppLoginDto = {
  otp: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type AppLoginResponse = {
  __typename?: 'AppLoginResponse';
  accessToken: Scalars['String']['output'];
  driverDocumentsStatus?: Maybe<DriverDocumentsStatusResponse>;
  expiresIn: Scalars['DateTime']['output'];
  permissionNames?: Maybe<Array<Scalars['String']['output']>>;
  permissions?: Maybe<Array<Permission>>;
  phoneNumber: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
  storeId?: Maybe<Scalars['Float']['output']>;
  tokenType: Scalars['String']['output'];
  username?: Maybe<Scalars['String']['output']>;
};

export type AuthResponse = {
  __typename?: 'AuthResponse';
  accessToken: Scalars['String']['output'];
  driverDocumentsStatus?: Maybe<DriverDocumentsStatusResponse>;
  expiresIn: Scalars['DateTime']['output'];
  permissionNames?: Maybe<Array<Scalars['String']['output']>>;
  permissions?: Maybe<Array<Permission>>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  refreshToken: Scalars['String']['output'];
  storeId?: Maybe<Scalars['Float']['output']>;
  tokenType: Scalars['String']['output'];
  username?: Maybe<Scalars['String']['output']>;
};

export type BalanceResponse = {
  __typename?: 'BalanceResponse';
  /** Balance breakdown by store */
  storeBalances: Array<StoreBalance>;
  /** Total balance across all stores as decimal string */
  totalBalance: Scalars['String']['output'];
};

export type BankResponse = {
  __typename?: 'BankResponse';
  code: Scalars['String']['output'];
  nameAr: Scalars['String']['output'];
  nameEn: Scalars['String']['output'];
};

export type BatchNotificationResponse = {
  __typename?: 'BatchNotificationResponse';
  failureCount: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  successCount: Scalars['Int']['output'];
};

export type Beneficiary = {
  __typename?: 'Beneficiary';
  bank: Scalars['String']['output'];
  bankCode: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  iban: Scalars['String']['output'];
  ibanPhoto?: Maybe<Media>;
  id: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  status: BeneficiaryStatus;
  updatedAt: Scalars['DateTime']['output'];
  user: User;
};

export type BeneficiaryFilterInput = {
  bankCode?: InputMaybe<Scalars['String']['input']>;
  createdAfter?: InputMaybe<Scalars['DateTime']['input']>;
  createdBefore?: InputMaybe<Scalars['DateTime']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<BeneficiaryStatus>;
  statuses?: InputMaybe<Array<BeneficiaryStatus>>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

/** Status of a beneficiary */
export enum BeneficiaryStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type CancelMrMandoobOrderDto = {
  orderId: Scalars['Int']['input'];
  reasonOfCancel: Scalars['String']['input'];
};

export type Cart = {
  __typename?: 'Cart';
  address?: Maybe<Address>;
  computes: Computes;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  isActive: Scalars['Boolean']['output'];
  isHost: Scalars['Boolean']['output'];
  isReady: Scalars['Boolean']['output'];
  items?: Maybe<Array<CartItem>>;
  /** Promo code applied to this cart */
  promoCode?: Maybe<Scalars['String']['output']>;
  scheduledAt?: Maybe<Scalars['DateTime']['output']>;
  shoppingSession: ShoppingSession;
  store?: Maybe<Store>;
  totalQty: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: User;
};

export type CartItem = {
  __typename?: 'CartItem';
  computes: Computes;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  note?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<ProductOption>>;
  price: Price;
  product: Product;
  quantity: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CommerceDataPurgeResult = {
  __typename?: 'CommerceDataPurgeResult';
  deletedAddresses: Scalars['Int']['output'];
  deletedAuditLogs: Scalars['Int']['output'];
  deletedBeneficiaries: Scalars['Int']['output'];
  deletedCartItemOptionLinks: Scalars['Int']['output'];
  deletedCartItems: Scalars['Int']['output'];
  deletedCarts: Scalars['Int']['output'];
  deletedDeviceTokens: Scalars['Int']['output'];
  deletedDriverIdentity: Scalars['Int']['output'];
  deletedDriverInfo: Scalars['Int']['output'];
  deletedDriverLicenses: Scalars['Int']['output'];
  deletedDriverOrderRequests: Scalars['Int']['output'];
  deletedDriverProfilePictures: Scalars['Int']['output'];
  deletedDriverTransactions: Scalars['Int']['output'];
  deletedDriverVehicleRegistrations: Scalars['Int']['output'];
  deletedDriverWithdrawals: Scalars['Int']['output'];
  deletedIntegrationLogsForUsers: Scalars['Int']['output'];
  deletedLedgerTransactions: Scalars['Int']['output'];
  deletedOrderItemOptionLinks: Scalars['Int']['output'];
  deletedOrderItems: Scalars['Int']['output'];
  deletedOrders: Scalars['Int']['output'];
  deletedPayments: Scalars['Int']['output'];
  deletedRefreshTokens: Scalars['Int']['output'];
  deletedShoppingSessions: Scalars['Int']['output'];
  deletedUserPermissionLinks: Scalars['Int']['output'];
  deletedUserSavedCards: Scalars['Int']['output'];
  deletedUsers: Scalars['Int']['output'];
  deletedWebhookLogs: Scalars['Int']['output'];
};

export type Computes = {
  __typename?: 'Computes';
  additionalCustomerFee?: Maybe<Scalars['Float']['output']>;
  afterDiscountDeliveryFee?: Maybe<Scalars['Float']['output']>;
  defaultDeliveryFee?: Maybe<Scalars['Float']['output']>;
  discountAmount: Scalars['Float']['output'];
  discountLevels?: Maybe<Array<DiscountLevel>>;
  discountMinimumCartAmount?: Maybe<Scalars['Float']['output']>;
  discountPartnerCoverageAmount?: Maybe<Scalars['Float']['output']>;
  discountRate: Scalars['Float']['output'];
  duePaymentAmount: Scalars['Float']['output'];
  effectiveDiscountRate?: Maybe<Scalars['Float']['output']>;
  minimumCartForFreeDelivery?: Maybe<Scalars['Float']['output']>;
  partnerDeliveryCoverageAmount: Scalars['Float']['output'];
  platformCommission?: Maybe<Scalars['Float']['output']>;
  promoCode?: Maybe<Scalars['String']['output']>;
  promoDiscountAmount?: Maybe<Scalars['Float']['output']>;
  subtotalAmount: Scalars['Float']['output'];
  totalAmount: Scalars['Float']['output'];
  /** Calculates the total combined discount (Plan + Promo + Delivery) */
  totalDiscountAmount: Scalars['Float']['output'];
};

export type CoordinateArgs = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type Country = {
  __typename?: 'Country';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  nameAr: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CreateAddressDto = {
  addressCategory?: InputMaybe<Address_Category>;
  addressCategoryLabel?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<Scalars['String']['input']>;
  fullAddress: Scalars['String']['input'];
  fullAddressAr: Scalars['String']['input'];
  isTemp?: Scalars['Boolean']['input'];
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  name: Scalars['String']['input'];
  nameAr: Scalars['String']['input'];
};

export type CreateBeneficiaryDto = {
  bankCode: Scalars['String']['input'];
  iban: Scalars['String']['input'];
  ibanPhotoId?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};

export type CreateDriverIdentityDto = {
  birthDate: Scalars['String']['input'];
  firstNameAr: Scalars['String']['input'];
  firstNameEn: Scalars['String']['input'];
  gender: Gender;
  imageId: Scalars['Int']['input'];
  lastNameAr: Scalars['String']['input'];
  lastNameEn: Scalars['String']['input'];
};

export type CreateDriverInfoDto = {
  /** City externalId from cities lookup (must be a city in the selected region) */
  deliveryAreaId: Scalars['String']['input'];
  /** Defaults to full_time when omitted */
  driverType?: InputMaybe<DriverType>;
  email: Scalars['String']['input'];
  idNumber: Scalars['String']['input'];
  /** Identity type externalId from identity-types lookup */
  idType: Scalars['String']['input'];
  isVehicleOwner: Scalars['Boolean']['input'];
  nationalityId: Scalars['Int']['input'];
  /** Region externalId from regions lookup */
  regionId: Scalars['String']['input'];
  /** Vehicle type externalId from car-types lookup */
  vehicleTypeId: Scalars['String']['input'];
};

export type CreateDriverLicenseDto = {
  expirationDate: Scalars['String']['input'];
  imageId: Scalars['Int']['input'];
  licenseNumber: Scalars['String']['input'];
};

export type CreateDriverProfilePictureDto = {
  imageId: Scalars['Int']['input'];
};

export type CreateDriverVehicleRegistrationDto = {
  imageId: Scalars['Int']['input'];
  ownerId: Scalars['String']['input'];
  plateNumber: Scalars['String']['input'];
  serialNumber: Scalars['String']['input'];
  vehicleBrand: Scalars['String']['input'];
  visaUserId: Scalars['String']['input'];
};

export type CreateDriverWithdrawalDto = {
  /** Withdrawal amount (must be less than or equal to driver balance) */
  amount: Scalars['String']['input'];
  /** ID of the beneficiary to withdraw to */
  beneficiaryId: Scalars['Int']['input'];
  /** Optional description for the withdrawal */
  description?: InputMaybe<Scalars['String']['input']>;
};

export type CreateFinanceTreeDto = {
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  nameAr: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type CreateFinanceTreeTransactionDto = {
  /** Transaction date (ISO 8601 format) */
  date: Scalars['String']['input'];
  /** Transaction description */
  description: Scalars['String']['input'];
  media?: InputMaybe<CreateMediaDto>;
  /** Transaction lines (must have at least one) */
  transactionLines: Array<CreateFinanceTreeTransactionLineDto>;
};

export type CreateFinanceTreeTransactionLineDto = {
  /** Credit amount */
  credit?: Scalars['Float']['input'];
  /** Debit amount */
  debit?: Scalars['Float']['input'];
  /** Description for this transaction line */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Finance tree account ID */
  financeTreeId: Scalars['Int']['input'];
};

export type CreateLedgerTransactionDto = {
  /** Amount as decimal string (can be positive or negative) */
  amountMinor: Scalars['String']['input'];
  /** Transaction description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Idempotency key to prevent duplicate transactions */
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<CreateMediaDto>;
  /** Order ID (optional, can be null for manual adjustments) */
  orderId?: InputMaybe<Scalars['Int']['input']>;
  /** Transaction status */
  status?: TransactionStatus;
  /** Store ID for this transaction */
  storeId: Scalars['Int']['input'];
  /** Type of transaction */
  type: TransactionType;
};

export type CreateMediaDto = {
  altText?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  fileName: Scalars['String']['input'];
  hash?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  isActive?: Scalars['Boolean']['input'];
  mimeType: Scalars['String']['input'];
  originalName: Scalars['String']['input'];
  size: Scalars['Int']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  thumbnailUrl?: InputMaybe<Scalars['String']['input']>;
  type: MediaType;
  url: Scalars['String']['input'];
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateNafathRequestDto = {
  deviceId?: InputMaybe<Scalars['String']['input']>;
  endUserIp?: InputMaybe<Scalars['String']['input']>;
  imei?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['String']['input']>;
  /** JWT locale preference: ar | en */
  local?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['String']['input']>;
  nationalId: Scalars['String']['input'];
  service?: NafathServiceType;
};

export type CreateOutOfStockDto = {
  outOfStock?: Scalars['Boolean']['input'];
  storeIds?: Array<Scalars['Int']['input']>;
};

export type CreatePartnerCategoryDto = {
  media?: InputMaybe<CreateMediaDto>;
  name: Scalars['String']['input'];
  nameAr: Scalars['String']['input'];
};

export type CreatePartnerDto = {
  address?: InputMaybe<Scalars['String']['input']>;
  coverImageId?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  imageId?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  nameAr: Scalars['String']['input'];
  partnerCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  planId: Scalars['Int']['input'];
  productImageId?: InputMaybe<Scalars['Int']['input']>;
};

export type CreatePartnerInvitationDto = {
  email: Scalars['String']['input'];
  storeId?: InputMaybe<Scalars['Int']['input']>;
};

export type CreatePermissionDto = {
  functions: Array<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  role: Scalars['String']['input'];
  userIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type CreatePlanDto = {
  commissionRate: Scalars['Int']['input'];
  deliveryPlan: DeliveryPlanDto;
  flashSaleDiscounts?: InputMaybe<Array<FlashSaleDiscountDto>>;
  groupDeliveryDiscounts?: InputMaybe<Array<GroupDeliveryDiscountDto>>;
  groupOrderDiscounts?: InputMaybe<Array<GroupOrderDiscountDto>>;
  individualOrderDiscounts?: InputMaybe<Array<IndividualOrderDiscountDto>>;
  minCommissionAmount: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  scheduledIndividualOrderDiscounts?: InputMaybe<Array<ScheduledIndividualOrderDiscountDto>>;
  urgentIndividualOrderDiscounts?: InputMaybe<Array<UrgentIndividualOrderDiscountDto>>;
};

export type CreateProductCategoryDto = {
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionAr?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  nameAr: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateProductDto = {
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionAr?: InputMaybe<Scalars['String']['input']>;
  /** Food quality time in minutes */
  foodQualityTimeMinutes?: InputMaybe<Scalars['Int']['input']>;
  imageId?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  nameAr: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  productCategoryId: Scalars['Int']['input'];
  productOptionCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  storeIds?: Array<Scalars['Int']['input']>;
};

export type CreateProductOptionCategoryDto = {
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionAr?: InputMaybe<Scalars['String']['input']>;
  max?: Scalars['Int']['input'];
  min?: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  nameAr: Scalars['String']['input'];
  productOptions: Array<ProductOptionDto>;
};

export type CreatePromoCodeDto = {
  code: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  discountType: PromoCodeDiscountType;
  discountValue: Scalars['Float']['input'];
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  maxDiscountAmount?: InputMaybe<Scalars['Float']['input']>;
  minCartAmount?: InputMaybe<Scalars['Float']['input']>;
  perUserLimit?: InputMaybe<Scalars['Int']['input']>;
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
  storeId?: InputMaybe<Scalars['Int']['input']>;
  usageLimit?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateShoppingSessionDto = {
  defaultPaymentShareType?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  endTimeMinutes?: InputMaybe<Scalars['Int']['input']>;
  scheduledType?: InputMaybe<Scalars['String']['input']>;
  storeId: Scalars['Int']['input'];
  type?: Scalars['String']['input'];
};

export type CreateStoreDto = {
  address?: InputMaybe<Scalars['String']['input']>;
  /** City externalId from Tawseel cities lookup (must be in the selected region) */
  cityId: Scalars['String']['input'];
  defaultWorkingHoursId?: InputMaybe<Scalars['Int']['input']>;
  latitude: Scalars['Float']['input'];
  locationImageId?: InputMaybe<Scalars['Int']['input']>;
  longitude: Scalars['Float']['input'];
  name: Scalars['String']['input'];
  nameAr: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  preparationTime?: InputMaybe<Scalars['Int']['input']>;
  /** Region externalId from Tawseel regions lookup */
  regionId: Scalars['String']['input'];
};

export type CreateTemporarilyClosedDto = {
  isTemporarilyClosed?: Scalars['Boolean']['input'];
  temporarilyClosedNote?: InputMaybe<Scalars['String']['input']>;
  temporarilyClosedNoteAr?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTransactionCategoryInput = {
  isEditable?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  nameAr?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type CreateWorkingHoursDto = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  items: Array<CreateWorkingHoursItemDto>;
  name: Scalars['String']['input'];
  nameAr: Scalars['String']['input'];
  priority?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  storeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type CreateWorkingHoursItemDto = {
  endTime: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
  weekday: Scalars['Int']['input'];
};

/** Driver document type options */
export enum Driver_Document_Type {
  DriversLicense = 'DRIVERS_LICENSE',
  Identity = 'IDENTITY',
  ProfilePicture = 'PROFILE_PICTURE',
  VehicleRegistration = 'VEHICLE_REGISTRATION'
}

/** Driver registration status options */
export enum Driver_Registration_Status {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  UnderReview = 'UNDER_REVIEW'
}

export type DailyOrderTrend = {
  __typename?: 'DailyOrderTrend';
  date: Scalars['String']['output'];
  orderCount: Scalars['Int']['output'];
  totalRevenue: Scalars['Float']['output'];
};

export type DeleteBeneficiaryDto = {
  id: Scalars['Int']['input'];
};

export type DeliveryConditionItem = {
  __typename?: 'DeliveryConditionItem';
  afterDiscountDeliveryFee?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  minimumCartAmount: Scalars['Float']['output'];
  partnerCoverageAmount: Scalars['Float']['output'];
  scheduledType: ScheduledType;
  updatedAt: Scalars['DateTime']['output'];
};

export type DeliveryConditionItemDto = {
  afterDiscountDeliveryFee?: InputMaybe<Scalars['Float']['input']>;
  minimumCartAmount: Scalars['Float']['input'];
  partnerCoverageAmount: Scalars['Float']['input'];
  scheduledType: ScheduledType;
};

/** Which fleet owns dispatch: INTERNAL (Robinfood drivers) or MR_MANDOOB. Exclusive — never both. */
export enum DeliveryFleet {
  Internal = 'INTERNAL',
  MrMandoob = 'MR_MANDOOB'
}

export type DeliveryLoginResponse = {
  __typename?: 'DeliveryLoginResponse';
  accessToken: Scalars['String']['output'];
  driverDocumentsStatus?: Maybe<DriverDocumentsStatusResponse>;
  expiresIn: Scalars['DateTime']['output'];
  permissionNames?: Maybe<Array<Scalars['String']['output']>>;
  permissions?: Maybe<Array<Permission>>;
  phoneNumber: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
  storeId?: Maybe<Scalars['Float']['output']>;
  tokenType: Scalars['String']['output'];
  username?: Maybe<Scalars['String']['output']>;
};

export type DeliveryOrderSubscriptionData = {
  __typename?: 'DeliveryOrderSubscriptionData';
  currency: Scalars['String']['output'];
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  invoiceId: Scalars['String']['output'];
  invoiceTotals: InvoiceTotals;
  orders: Array<InvoiceOrderItem>;
  requestId: Scalars['Int']['output'];
  requestStatus: DriverOrderRequestStatus;
};

export type DeliveryOrderWithStatus = {
  __typename?: 'DeliveryOrderWithStatus';
  arrivedToRestaurantAt?: Maybe<Scalars['DateTime']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  currency: Scalars['String']['output'];
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  invoiceId: Scalars['String']['output'];
  invoiceTotals: InvoiceTotals;
  notifiedAt?: Maybe<Scalars['DateTime']['output']>;
  orders: Array<InvoiceOrderItem>;
  requestId: Scalars['Int']['output'];
  requestStatus: DriverOrderRequestStatus;
  respondedAt?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
};

export type DeliveryPlan = {
  __typename?: 'DeliveryPlan';
  createdAt: Scalars['DateTime']['output'];
  defaultDeliveryFee: Scalars['Float']['output'];
  id: Scalars['Float']['output'];
  items: Array<DeliveryConditionItem>;
  updatedAt: Scalars['DateTime']['output'];
};

export type DeliveryPlanDto = {
  defaultDeliveryFee: Scalars['Float']['input'];
  items: Array<DeliveryConditionItemDto>;
};

export type DeliverySetting = {
  __typename?: 'DeliverySetting';
  costPerExtraOrderFreelancerDriver: Scalars['Float']['output'];
  costPerExtraOrderFullTimeDriver: Scalars['Float']['output'];
  costPerOrderFreelancerDriver: Scalars['Float']['output'];
  costPerOrderFullTimeDriver: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  salaryFixedCost: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type DeviceToken = {
  __typename?: 'DeviceToken';
  appType: DeviceTokenAppType;
  appVersion?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deviceId?: Maybe<Scalars['String']['output']>;
  deviceModel?: Maybe<Scalars['String']['output']>;
  deviceName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  isActive: Scalars['Boolean']['output'];
  lang: Scalars['String']['output'];
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>;
  osVersion?: Maybe<Scalars['String']['output']>;
  platform: Scalars['String']['output'];
  token: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Float']['output']>;
};

export enum DeviceTokenAppType {
  Customer = 'CUSTOMER',
  Driver = 'DRIVER',
  Partner = 'PARTNER'
}

export type DeviceTokenResponse = {
  __typename?: 'DeviceTokenResponse';
  deviceTokenId?: Maybe<Scalars['Float']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DiscountLevel = {
  __typename?: 'DiscountLevel';
  discountRate: Scalars['Float']['output'];
  maxDiscountAmount?: Maybe<Scalars['Float']['output']>;
  minimumCartAmount: Scalars['Int']['output'];
  numberOfMembers?: Maybe<Scalars['Int']['output']>;
  partnerCoverageRate?: Maybe<Scalars['Float']['output']>;
};

export type DownloadLedgerTransactionsResponse = {
  __typename?: 'DownloadLedgerTransactionsResponse';
  /** Base64 encoded Excel file content */
  fileContent: Scalars['String']['output'];
  /** Suggested filename for download */
  filename: Scalars['String']['output'];
  /** MIME type of the file */
  mimeType: Scalars['String']['output'];
};

export type DriverCurrentLocation = {
  __typename?: 'DriverCurrentLocation';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  /** Timestamp when the location was last updated */
  timestamp: Scalars['DateTime']['output'];
};

export type DriverDocument = DriverIdentity | DriverLicense | DriverProfilePicture | DriverVehicleRegistration;

export type DriverDocumentsStatusResponse = {
  __typename?: 'DriverDocumentsStatusResponse';
  driverInfo?: Maybe<Scalars['String']['output']>;
  identity?: Maybe<Scalars['String']['output']>;
  license?: Maybe<Scalars['String']['output']>;
  profilePicture?: Maybe<Scalars['String']['output']>;
  vehicleRegistration?: Maybe<Scalars['String']['output']>;
};

export type DriverFilterInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  idNumber?: InputMaybe<Scalars['String']['input']>;
  idType?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  registrationStatus?: InputMaybe<Driver_Registration_Status>;
};

export type DriverIdentity = {
  __typename?: 'DriverIdentity';
  birthDate: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  firstNameAr: Scalars['String']['output'];
  firstNameEn: Scalars['String']['output'];
  gender: Gender;
  id: Scalars['Float']['output'];
  image: Media;
  lastNameAr: Scalars['String']['output'];
  lastNameEn: Scalars['String']['output'];
  rejectionReason?: Maybe<Scalars['String']['output']>;
  status: Driver_Registration_Status;
  updatedAt: Scalars['DateTime']['output'];
  user: User;
};

export type DriverInfo = {
  __typename?: 'DriverInfo';
  autoAcceptOrderRequest: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  deliveryArea?: Maybe<TawseelLookupItemType>;
  deliveryAreaId?: Maybe<Scalars['String']['output']>;
  driverIntegrationId?: Maybe<Scalars['String']['output']>;
  driverStatus?: Maybe<DriverStatus>;
  driverType?: Maybe<DriverType>;
  email: Scalars['String']['output'];
  id: Scalars['Float']['output'];
  idNumber: Scalars['String']['output'];
  idType?: Maybe<Scalars['String']['output']>;
  idTypeInfo?: Maybe<TawseelLookupItemType>;
  isVehicleOwner: Scalars['Boolean']['output'];
  nationality: Country;
  region?: Maybe<TawseelLookupItemType>;
  regionId?: Maybe<Scalars['String']['output']>;
  registrationStatus: Driver_Registration_Status;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  vehicleType?: Maybe<TawseelLookupItemType>;
  vehicleTypeId?: Maybe<Scalars['String']['output']>;
};

export type DriverLicense = {
  __typename?: 'DriverLicense';
  createdAt: Scalars['DateTime']['output'];
  expirationDate: Scalars['String']['output'];
  id: Scalars['Float']['output'];
  image: Media;
  licenseNumber: Scalars['String']['output'];
  rejectionReason?: Maybe<Scalars['String']['output']>;
  status: Driver_Registration_Status;
  updatedAt: Scalars['DateTime']['output'];
  user: User;
};

export type DriverListItem = {
  __typename?: 'DriverListItem';
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type DriverOrderFilterInput = {
  createdAfter?: InputMaybe<Scalars['String']['input']>;
  createdBefore?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DriverOrderRequestStatus>;
};

export type DriverOrderRequest = {
  __typename?: 'DriverOrderRequest';
  arrivedToRestaurantAt?: Maybe<Scalars['DateTime']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deliveryProofMedia?: Maybe<Media>;
  distanceKm?: Maybe<Scalars['Float']['output']>;
  driver: User;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Float']['output'];
  notifiedAt?: Maybe<Scalars['DateTime']['output']>;
  order: Order;
  orders?: Maybe<Array<Order>>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  respondedAt?: Maybe<Scalars['DateTime']['output']>;
  responseReason?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Status of a driver order request */
export enum DriverOrderRequestStatus {
  Accepted = 'ACCEPTED',
  ArrivedToRestaurant = 'ARRIVED_TO_RESTAURANT',
  Completed = 'COMPLETED',
  Expired = 'EXPIRED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  SystemRejected = 'SYSTEM_REJECTED'
}

export type DriverPeriodEarningsType = {
  __typename?: 'DriverPeriodEarningsType';
  /** Sum of POSTED DELIVERY_FEE, EXTRA_ORDER, and DISTANCE_FEE (DECIMAL as string) */
  deliveryFee: Scalars['String']['output'];
  /** Localized period label, e.g. "This day (8 February)" / "هذا اليوم (٨ فبراير)" */
  label: Scalars['String']['output'];
  /** Sum of POSTED TIP transactions (DECIMAL as string) */
  other: Scalars['String']['output'];
  /** Absolute sum of POSTED PENALTY transactions (DECIMAL as string) */
  penalty: Scalars['String']['output'];
  period: DriverStatisticsPeriod;
  /** Net period revenue: deliveryFee + other - penalty (DECIMAL as string) */
  total: Scalars['String']['output'];
};

export type DriverPeriodStatisticsType = {
  __typename?: 'DriverPeriodStatisticsType';
  completedRequests: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  /** Percentage of assigned orders whose deliveredAt is on or before scheduledAt */
  onTimeDeliveryRate: Scalars['Float']['output'];
  period: DriverStatisticsPeriod;
  /** Percentage of requests with status accepted, arrived_to_restaurant, or completed */
  requestAcceptanceRate: Scalars['Float']['output'];
  requests: Scalars['Int']['output'];
};

export type DriverProfilePicture = {
  __typename?: 'DriverProfilePicture';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  image: Media;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  status: Driver_Registration_Status;
  updatedAt: Scalars['DateTime']['output'];
  user: User;
};

export type DriverRequestCountsType = {
  __typename?: 'DriverRequestCountsType';
  inProgress: Scalars['Int']['output'];
  totalPendingRequests: Scalars['Int']['output'];
};

/** Time window for driver statistics */
export enum DriverStatisticsPeriod {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

export type DriverStatsType = {
  __typename?: 'DriverStatsType';
  acceptanceRate: Scalars['Float']['output'];
  accepted: Scalars['Int']['output'];
  expired: Scalars['Int']['output'];
  pending: Scalars['Int']['output'];
  rejected: Scalars['Int']['output'];
  totalRequests: Scalars['Int']['output'];
};

export enum DriverStatus {
  Available = 'AVAILABLE',
  Busy = 'BUSY',
  Offline = 'OFFLINE'
}

/** Employment type of the driver */
export enum DriverType {
  Freelance = 'FREELANCE',
  FullTime = 'FULL_TIME'
}

export type DriverVehicleRegistration = {
  __typename?: 'DriverVehicleRegistration';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  image: Media;
  ownerId: Scalars['String']['output'];
  plateNumber: Scalars['String']['output'];
  rejectionReason?: Maybe<Scalars['String']['output']>;
  serialNumber: Scalars['String']['output'];
  status: Driver_Registration_Status;
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  vehicleBrand: Scalars['String']['output'];
  visaUserId: Scalars['String']['output'];
};

export type DriverWithdrawal = {
  __typename?: 'DriverWithdrawal';
  /** DECIMAL(20,2) as string */
  amountMinor: Scalars['String']['output'];
  /** Driver balance at time of withdrawal */
  balanceAtTime?: Maybe<Scalars['String']['output']>;
  beneficiary: Beneficiary;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  driver: User;
  id: Scalars['Float']['output'];
  rejectionReason?: Maybe<Scalars['String']['output']>;
  status: WithdrawalStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type DriverWithdrawalFilterInput = {
  /** Filter by beneficiary ID */
  beneficiaryId?: InputMaybe<Scalars['Int']['input']>;
  /** Include withdrawals created on/after this date (YYYY-MM-DD or ISO 8601) */
  createdAfter?: InputMaybe<Scalars['String']['input']>;
  /** Include withdrawals created on/before this date (YYYY-MM-DD or ISO 8601) */
  createdBefore?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<WithdrawalStatus>;
  statuses?: InputMaybe<Array<WithdrawalStatus>>;
};

export type EstimatedDeliveryTime = {
  __typename?: 'EstimatedDeliveryTime';
  /** Batching time for scheduled orders, in minutes */
  batchingTimeForScheduled: Scalars['Int']['output'];
  /** Batching time for smart orders, in minutes */
  batchingTimeForSmart: Scalars['Int']['output'];
  /** Delivery margin in minutes from system configuration */
  deliveryMargin: Scalars['Int']['output'];
  /** Travel duration in minutes outside rush hour */
  durationInNoneRushHour: Scalars['Int']['output'];
  /** Travel duration in minutes during rush hour */
  durationInRushHour: Scalars['Int']['output'];
  /** Whether the current time falls within a configured rush-hour window */
  isInRushHour: Scalars['Boolean']['output'];
  /** preparationTime + travel duration + orderSafetyMargin + batchingTimeForSmart (minutes) */
  normal: Scalars['Int']['output'];
  /** Order safety margin in minutes from system configuration */
  orderSafetyMargin: Scalars['Int']['output'];
  /** Store preparation time in minutes used in the estimates */
  preparationTime: Scalars['Int']['output'];
  /** preparationTime + travel duration + orderSafetyMargin + batchingTimeForScheduled (minutes) */
  scheduled: Scalars['Int']['output'];
  /** preparationTime + travel duration + orderSafetyMargin (minutes) */
  urgent: Scalars['Int']['output'];
};

export type FinanceTree = {
  __typename?: 'FinanceTree';
  children?: Maybe<Array<FinanceTree>>;
  createdAt: Scalars['DateTime']['output'];
  editable: Scalars['Boolean']['output'];
  id: Scalars['Float']['output'];
  /** Depth level in the tree hierarchy */
  level?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  nameAr: Scalars['String']['output'];
  parent?: Maybe<FinanceTree>;
  parentId?: Maybe<Scalars['Float']['output']>;
  serialNumber: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type FinanceTreeTransaction = {
  __typename?: 'FinanceTreeTransaction';
  createdAt: Scalars['DateTime']['output'];
  /** Transaction date */
  date: Scalars['DateTime']['output'];
  /** Transaction description */
  description: Scalars['String']['output'];
  id: Scalars['Float']['output'];
  image?: Maybe<Media>;
  imageId?: Maybe<Scalars['Float']['output']>;
  /** Whether the transaction is balanced (debit = credit) */
  isBalanced: Scalars['Boolean']['output'];
  /** Total count of transaction lines in this transaction */
  total: Scalars['Float']['output'];
  /** Total credit amount (sum of all transaction lines) */
  totalCredit: Scalars['Float']['output'];
  /** Total debit amount (sum of all transaction lines) */
  totalDebit: Scalars['Float']['output'];
  /** Transaction lines with finance tree accounts */
  transactionLines: Array<FinanceTreeTransactionLine>;
  /** Auto-generated transaction number */
  transactionNumber?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type FinanceTreeTransactionFilterDto = {
  /** Filter by date from (ISO 8601 format) */
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  /** Filter by date to (ISO 8601 format) */
  dateTo?: InputMaybe<Scalars['String']['input']>;
  /** Search by transaction description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Filter by finance tree ID (includes all sub-levels/descendants) */
  financeTreeId?: InputMaybe<Scalars['Int']['input']>;
};

export type FinanceTreeTransactionLine = {
  __typename?: 'FinanceTreeTransactionLine';
  createdAt: Scalars['DateTime']['output'];
  /** Credit amount */
  credit: Scalars['Float']['output'];
  /** Debit amount */
  debit: Scalars['Float']['output'];
  /** Description for this transaction line */
  description?: Maybe<Scalars['String']['output']>;
  /** The finance tree account for this line */
  financeTree: FinanceTree;
  /** Reference to the finance tree account */
  financeTreeId: Scalars['Int']['output'];
  id: Scalars['Float']['output'];
  transaction: FinanceTreeTransaction;
  /** Reference to the finance tree transaction */
  transactionId: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type FinanceTreeTransactionLineFilterDto = {
  /** Filter by transaction date from (ISO 8601 format) */
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  /** Filter by transaction date to (ISO 8601 format) */
  dateTo?: InputMaybe<Scalars['String']['input']>;
  /** Search by line description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Filter by finance tree ID (includes current level and all sub-levels/descendants) */
  financeTreeId?: InputMaybe<Scalars['Int']['input']>;
  /** Filter by maximum credit amount */
  maxCredit?: InputMaybe<Scalars['Float']['input']>;
  /** Filter by maximum debit amount */
  maxDebit?: InputMaybe<Scalars['Float']['input']>;
  /** Filter by minimum credit amount */
  minCredit?: InputMaybe<Scalars['Float']['input']>;
  /** Filter by minimum debit amount */
  minDebit?: InputMaybe<Scalars['Float']['input']>;
  /** Filter by specific transaction ID */
  transactionId?: InputMaybe<Scalars['Int']['input']>;
};

export type FinanceTreeTransactionLineResponse = {
  __typename?: 'FinanceTreeTransactionLineResponse';
  /** Number of items per page */
  limit: Scalars['Int']['output'];
  /** Current page number */
  page: Scalars['Int']['output'];
  /** Total count of transaction lines matching the filters */
  total: Scalars['Int']['output'];
  /** Total number of pages */
  totalPages: Scalars['Int']['output'];
  /** List of finance tree transaction lines */
  transactionLines: Array<FinanceTreeTransactionLine>;
};

export type FinanceTreeTransactionResponse = {
  __typename?: 'FinanceTreeTransactionResponse';
  /** List of finance tree transactions */
  transactions: Array<FinanceTreeTransaction>;
};

export type FinanceTreeWithLevel = {
  __typename?: 'FinanceTreeWithLevel';
  /** Balance calculated as total debit minus total credit (including all sub-levels) */
  balance: Scalars['Float']['output'];
  children?: Maybe<Array<FinanceTree>>;
  createdAt: Scalars['DateTime']['output'];
  editable: Scalars['Boolean']['output'];
  id: Scalars['Float']['output'];
  /** The depth level of this item in the tree (1 for root, 2 for first level children, etc.) */
  level: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  nameAr: Scalars['String']['output'];
  parent?: Maybe<FinanceTree>;
  parentId?: Maybe<Scalars['Float']['output']>;
  serialNumber: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  /** Total credit amount including all sub-levels */
  totalCredit: Scalars['Float']['output'];
  /** Total debit amount including all sub-levels */
  totalDebit: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type FlashSaleDiscount = {
  __typename?: 'FlashSaleDiscount';
  createdAt: Scalars['DateTime']['output'];
  discountRate: Scalars['Float']['output'];
  id: Scalars['Float']['output'];
  maxDiscountAmount?: Maybe<Scalars['Float']['output']>;
  minimumCartAmount: Scalars['Float']['output'];
  numberOfMembers: Scalars['Int']['output'];
  partnerCoverageRate: Scalars['Float']['output'];
  partnerCoverageType: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type FlashSaleDiscountDto = {
  discountRate: Scalars['Float']['input'];
  maxDiscountAmount?: InputMaybe<Scalars['Float']['input']>;
  minimumCartAmount: Scalars['Float']['input'];
  numberOfMembers: Scalars['Int']['input'];
  partnerCoverageRate: Scalars['Float']['input'];
  partnerCoverageType: PartnerCoverageType;
};

export type FlashSale_Public = {
  __typename?: 'FlashSale_Public';
  coverImageUrl?: Maybe<Scalars['String']['output']>;
  /** Delivery fee configuration from this store's plan, projected for the nearby stores UI */
  deliveryPlan?: Maybe<NearbyStoreDeliveryPlan>;
  distance: Scalars['Float']['output'];
  duration: Scalars['Int']['output'];
  endTime: Scalars['DateTime']['output'];
  /** Estimated end-to-end delivery times by order type, plus rush-hour travel durations */
  estimatedDeliveryTime: EstimatedDeliveryTime;
  expiryMinutes: Scalars['Int']['output'];
  flashSaleDiscount?: Maybe<FlashSaleDiscount>;
  /** Max discountRate from this store's plan flashSaleDiscounts */
  flashSaleMaxDiscount?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  isOnline: Scalars['Boolean']['output'];
  isTemporarilyClosed: Scalars['Boolean']['output'];
  lookingForCustomerMinutes: Scalars['Int']['output'];
  orderFinishTimeMinutes: Scalars['Int']['output'];
  partnerCategories?: Maybe<Array<PartnerCategory>>;
  partnerName: Scalars['String']['output'];
  preparationTime?: Maybe<Scalars['Int']['output']>;
  productImageUrl?: Maybe<Scalars['String']['output']>;
  storeId: Scalars['Int']['output'];
  storeName: Scalars['String']['output'];
  storeNameAr: Scalars['String']['output'];
  temporarilyClosedNote?: Maybe<Scalars['String']['output']>;
  temporarilyClosedNoteAr?: Maybe<Scalars['String']['output']>;
  totalTrip?: Maybe<TotalTrip_Public>;
  workingHours?: Maybe<Array<WorkingHoursItem_Public>>;
};

/** IN_PROGRESS while the courier is still on the order, DELIVERED once it is completed */
export enum FulfillmentProgressStatus {
  Delivered = 'DELIVERED',
  InProgress = 'IN_PROGRESS'
}

export type FulfillmentRequest = {
  __typename?: 'FulfillmentRequest';
  arrivedToRestaurantAt?: Maybe<Scalars['DateTime']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  courierName?: Maybe<Scalars['String']['output']>;
  courierPhone?: Maybe<Scalars['String']['output']>;
  driverId?: Maybe<Scalars['Int']['output']>;
  fleet: DeliveryFleet;
  mrMandoobOrderId?: Maybe<Scalars['String']['output']>;
  notifiedAt?: Maybe<Scalars['DateTime']['output']>;
  orderId: Scalars['Int']['output'];
  /** Set for live and completed attempts. Null for rejected, expired, or system-rejected history. */
  progressStatus?: Maybe<FulfillmentProgressStatus>;
  /** DriverOrderRequest.id. Null for Mr Mandoob. */
  requestId?: Maybe<Scalars['Int']['output']>;
  requestStatus: DriverOrderRequestStatus;
  respondedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Gender options */
export enum Gender {
  Female = 'FEMALE',
  Male = 'MALE'
}

export type GetAllPartnersBalanceFilterDto = {
  /** Calculate balance from this date */
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  /** Calculate balance up to this date */
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter by specific partner ID */
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  /** Filter by specific store IDs */
  storeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type GetBalanceFilterDto = {
  /** Calculate balance up to this date */
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  /** Calculate balance from this date */
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter by specific store IDs (partner can only access their stores) */
  storeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type GetNafathStatusDto = {
  nationalId?: InputMaybe<Scalars['String']['input']>;
  refreshFromElm?: InputMaybe<Scalars['Boolean']['input']>;
  requestId?: InputMaybe<Scalars['String']['input']>;
  transId?: InputMaybe<Scalars['String']['input']>;
};

export type GetOrderStatisticsInput = {
  /** End date for the statistics range */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter by specific partner ID */
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  /** Start date for the statistics range */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter by order status */
  status?: InputMaybe<Scalars['String']['input']>;
  /** Filter by specific store ID */
  storeId?: InputMaybe<Scalars['Int']['input']>;
};

export type GetPartnerStatisticsInput = {
  /** End date for the statistics range */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter by specific partner ID */
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  /** Start date for the statistics range */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter by specific store ID */
  storeId?: InputMaybe<Scalars['Int']['input']>;
};

export type GoogleMapsRushHourRule = {
  __typename?: 'GoogleMapsRushHourRule';
  /** Optional date in KSA timezone (YYYY-MM-DD). Null means default. */
  date?: Maybe<Scalars['String']['output']>;
  /** Margin in minutes added/removed based on rush hour. */
  marginMinutes: Scalars['Float']['output'];
  /** Start time in KSA timezone (HH:mm, 24h). */
  timeFrom: Scalars['String']['output'];
  /** End time in KSA timezone (HH:mm, 24h). */
  timeTo: Scalars['String']['output'];
};

export type GoogleMapsRushHours = {
  __typename?: 'GoogleMapsRushHours';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  /** Rush hour rules used for Google Maps cache margin adjustments (KSA time) */
  rules: Array<GoogleMapsRushHourRule>;
  updatedAt: Scalars['DateTime']['output'];
};

export type GroupDeliveryDiscount = {
  __typename?: 'GroupDeliveryDiscount';
  createdAt: Scalars['DateTime']['output'];
  discountRate: Scalars['Float']['output'];
  id: Scalars['Float']['output'];
  maxDiscountAmount?: Maybe<Scalars['Float']['output']>;
  minimumCartAmount: Scalars['Float']['output'];
  numberOfMembers: Scalars['Int']['output'];
  partnerCoverageRate: Scalars['Float']['output'];
  partnerCoverageType: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type GroupDeliveryDiscountDto = {
  discountRate: Scalars['Float']['input'];
  maxDiscountAmount?: InputMaybe<Scalars['Float']['input']>;
  minimumCartAmount: Scalars['Float']['input'];
  numberOfMembers: Scalars['Int']['input'];
  partnerCoverageRate: Scalars['Float']['input'];
  partnerCoverageType: PartnerCoverageType;
};

export type GroupOrderDiscount = {
  __typename?: 'GroupOrderDiscount';
  createdAt: Scalars['DateTime']['output'];
  discountRate: Scalars['Float']['output'];
  id: Scalars['Float']['output'];
  maxDiscountAmount?: Maybe<Scalars['Float']['output']>;
  minimumCartAmount: Scalars['Float']['output'];
  numberOfMembers: Scalars['Int']['output'];
  partnerCoverageRate: Scalars['Float']['output'];
  partnerCoverageType: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type GroupOrderDiscountDto = {
  discountRate: Scalars['Float']['input'];
  maxDiscountAmount?: InputMaybe<Scalars['Float']['input']>;
  minimumCartAmount: Scalars['Float']['input'];
  numberOfMembers: Scalars['Int']['input'];
  partnerCoverageRate: Scalars['Float']['input'];
  partnerCoverageType: PartnerCoverageType;
};

export type GroupedItemsByPhoneDto = {
  __typename?: 'GroupedItemsByPhoneDto';
  items: Array<GroupedOrderItemDto>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber: Scalars['String']['output'];
};

export type GroupedOrderItemDto = {
  __typename?: 'GroupedOrderItemDto';
  discountAmount: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  note?: Maybe<Scalars['String']['output']>;
  options: Array<OrderItemOptionDto>;
  productImageUrl?: Maybe<Scalars['String']['output']>;
  productName: Scalars['String']['output'];
  productNameAr: Scalars['String']['output'];
  productPrice: Scalars['Float']['output'];
  quantity: Scalars['Int']['output'];
  subtotalAmount: Scalars['Float']['output'];
  totalAmount: Scalars['Float']['output'];
};

export type HyperpayApiMutationResult = {
  __typename?: 'HyperpayApiMutationResult';
  /** HyperPay checkout id (create) or the id passed to status. */
  checkoutId?: Maybe<Scalars['String']['output']>;
  /** Raw HyperPay API response. */
  data?: Maybe<Scalars['JSONObject']['output']>;
  /** Human-readable failure reason (e.g. capture after reverse, reverse after capture). */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** merchantTransactionId from create checkout. */
  merchantTransactionId?: Maybe<Scalars['String']['output']>;
  /** HyperPay payment id (capture / reverse). */
  paymentId?: Maybe<Scalars['String']['output']>;
  /** HyperPay result.code from the API response. */
  resultCode?: Maybe<Scalars['String']['output']>;
  /** HyperPay result.description from the API response. */
  resultDescription?: Maybe<Scalars['String']['output']>;
  /** True when HyperPay result.code indicates a successful operation. */
  success: Scalars['Boolean']['output'];
};

export type IndividualOrderDiscount = {
  __typename?: 'IndividualOrderDiscount';
  createdAt: Scalars['DateTime']['output'];
  discountRate: Scalars['Float']['output'];
  id: Scalars['Float']['output'];
  maxDiscountAmount?: Maybe<Scalars['Float']['output']>;
  minimumCartAmount: Scalars['Float']['output'];
  partnerCoverageRate: Scalars['Float']['output'];
  partnerCoverageType: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type IndividualOrderDiscountDto = {
  discountRate: Scalars['Float']['input'];
  maxDiscountAmount?: InputMaybe<Scalars['Float']['input']>;
  minimumCartAmount: Scalars['Float']['input'];
  partnerCoverageRate: Scalars['Float']['input'];
  partnerCoverageType: PartnerCoverageType;
};

export type Invitation = {
  __typename?: 'Invitation';
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['Float']['output'];
  partnerId: Scalars['Int']['output'];
  partnerName?: Maybe<Scalars['String']['output']>;
  storeId?: Maybe<Scalars['Int']['output']>;
  storeName?: Maybe<Scalars['String']['output']>;
  token: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type InvoiceDelivery = {
  __typename?: 'InvoiceDelivery';
  address: InvoiceDeliveryAddress;
  details?: Maybe<Scalars['String']['output']>;
  recipient: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type InvoiceDeliveryAddress = {
  __typename?: 'InvoiceDeliveryAddress';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  street: Scalars['String']['output'];
};

export type InvoiceEarnings = {
  __typename?: 'InvoiceEarnings';
  deliveryFee: Scalars['Float']['output'];
  distanceFee: Scalars['Float']['output'];
  extra: Scalars['Float']['output'];
  tip: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
};

export type InvoiceOrderDriver = {
  __typename?: 'InvoiceOrderDriver';
  name: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  vehicleNumber?: Maybe<Scalars['String']['output']>;
  vehicleType?: Maybe<Scalars['String']['output']>;
};

export type InvoiceOrderItem = {
  __typename?: 'InvoiceOrderItem';
  chatwootDriverConversationId?: Maybe<Scalars['String']['output']>;
  deliveredAt?: Maybe<Scalars['DateTime']['output']>;
  deliveries: InvoiceDelivery;
  deliveryTime: Scalars['String']['output'];
  driver?: Maybe<InvoiceOrderDriver>;
  itemsCount: Scalars['Int']['output'];
  orderId: Scalars['Int']['output'];
  orderNumber: Scalars['String']['output'];
  orderSubtotal: Scalars['Float']['output'];
  pickup: InvoicePickup;
  products: Array<InvoiceProduct>;
  productsTotal: Scalars['Float']['output'];
  status: OrderStatus;
};

export type InvoicePickup = {
  __typename?: 'InvoicePickup';
  address: InvoicePickupAddress;
  locationImage?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
};

export type InvoicePickupAddress = {
  __typename?: 'InvoicePickupAddress';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  street: Scalars['String']['output'];
};

export type InvoiceProduct = {
  __typename?: 'InvoiceProduct';
  name: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<InvoiceProductOption>>;
  price: Scalars['Float']['output'];
  priceAfterDiscount: Scalars['Float']['output'];
  productFullPrice: Scalars['Float']['output'];
  productNameAr: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
};

export type InvoiceProductOption = {
  __typename?: 'InvoiceProductOption';
  label: Scalars['String']['output'];
  labelAr: Scalars['String']['output'];
  originalPrice: Scalars['Float']['output'];
  priceAfterDiscount: Scalars['Float']['output'];
};

export type InvoiceTotals = {
  __typename?: 'InvoiceTotals';
  earnings: InvoiceEarnings;
  ordersCount: Scalars['Int']['output'];
  ordersSubtotal: Scalars['Float']['output'];
  ordersTotal: Scalars['Float']['output'];
};

export type JoinSessionDto = {
  id: Scalars['Int']['input'];
};

export type LedgerTransaction = {
  __typename?: 'LedgerTransaction';
  /** DECIMAL(20,2) as string */
  amountMinor: Scalars['String']['output'];
  availableAt: Scalars['DateTime']['output'];
  correlationId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  idempotencyKey?: Maybe<Scalars['String']['output']>;
  media?: Maybe<Media>;
  meta?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Order>;
  postedAt: Scalars['DateTime']['output'];
  status: TransactionStatus;
  store: Store;
  type: TransactionType;
  updatedAt: Scalars['DateTime']['output'];
};

export type LedgerTransactionGql = {
  __typename?: 'LedgerTransactionGQL';
  amountMinor: Scalars['String']['output'];
  availableAt: Scalars['DateTime']['output'];
  correlationId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  idempotencyKey?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['Float']['output']>;
  partner: PartnerInfo;
  postedAt: Scalars['DateTime']['output'];
  status: TransactionStatus;
  store: StoreInfo;
  storeId: Scalars['Float']['output'];
  type: TransactionType;
};

export type LedgerTransactionsFilter = {
  amountSign?: InputMaybe<Scalars['String']['input']>;
  availableFrom?: InputMaybe<Scalars['DateTime']['input']>;
  availableTo?: InputMaybe<Scalars['DateTime']['input']>;
  createdFrom?: InputMaybe<Scalars['DateTime']['input']>;
  createdTo?: InputMaybe<Scalars['DateTime']['input']>;
  maxAmount?: InputMaybe<Scalars['Float']['input']>;
  minAmount?: InputMaybe<Scalars['Float']['input']>;
  orderId?: InputMaybe<Scalars['Int']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  postedFrom?: InputMaybe<Scalars['DateTime']['input']>;
  postedTo?: InputMaybe<Scalars['DateTime']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<TransactionStatus>>;
  storeId?: InputMaybe<Scalars['Int']['input']>;
  types?: InputMaybe<Array<TransactionType>>;
};

export type LedgerTransactionsPage = {
  __typename?: 'LedgerTransactionsPage';
  hasMore: Scalars['Boolean']['output'];
  items: Array<LedgerTransactionGql>;
  total: Scalars['Int']['output'];
};

export type LocalizedTextInput = {
  ar: Scalars['String']['input'];
  en: Scalars['String']['input'];
};

export type MaintenanceStatus = {
  __typename?: 'MaintenanceStatus';
  isUnderMaintenance: Scalars['Boolean']['output'];
};

export type ManageTopicInput = {
  deviceTokens: Array<Scalars['String']['input']>;
  topic: Scalars['String']['input'];
};

export type Media = {
  __typename?: 'Media';
  /** Alt text for accessibility */
  altText?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** Description or caption */
  description?: Maybe<Scalars['String']['output']>;
  /** Duration for videos/audio in seconds */
  duration?: Maybe<Scalars['Int']['output']>;
  expiresAt?: Maybe<Scalars['Timestamp']['output']>;
  fileName: Scalars['String']['output'];
  /** File hash for duplicate detection */
  hash?: Maybe<Scalars['String']['output']>;
  /** Height for images/videos */
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Float']['output'];
  isActive: Scalars['Boolean']['output'];
  /** MIME type of the file */
  mimeType: Scalars['String']['output'];
  originalName: Scalars['String']['output'];
  partner?: Maybe<Partner>;
  products?: Maybe<Array<Product>>;
  /** File size in bytes */
  size: Scalars['Int']['output'];
  /** Tags for categorization */
  tags?: Maybe<Array<Scalars['String']['output']>>;
  type: MediaType;
  updatedAt: Scalars['DateTime']['output'];
  /** Signed access URL for the media file */
  url: Scalars['String']['output'];
  /** Width for images/videos */
  width?: Maybe<Scalars['Int']['output']>;
};

/** The supported media file types */
export enum MediaType {
  /** Audio files (MP3, WAV, etc.) */
  Audio = 'AUDIO',
  /** Document files (PDF, DOC, DOCX) */
  Document = 'DOCUMENT',
  /** Image files (PNG, JPEG, WebP, GIF, SVG) */
  Image = 'IMAGE',
  /** Unknown or unsupported file types */
  Unknown = 'UNKNOWN',
  /** Video files (MP4, WebM, MOV) */
  Video = 'VIDEO'
}

export type MrMandoobAddOrderResultModel = {
  __typename?: 'MrMandoobAddOrderResultModel';
  /** Distance in KM */
  distanceKm: Scalars['String']['output'];
  message: Scalars['String']['output'];
  orderId: Scalars['Int']['output'];
};

export type MrMandoobCustomerDto = {
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type MrMandoobMutationResultModel = {
  __typename?: 'MrMandoobMutationResultModel';
  message: Scalars['String']['output'];
};

export type MrMandoobOrderRequest = {
  __typename?: 'MrMandoobOrderRequest';
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  arrivedToStoreAt?: Maybe<Scalars['DateTime']['output']>;
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  courierId?: Maybe<Scalars['Int']['output']>;
  courierLat?: Maybe<Scalars['Float']['output']>;
  courierLng?: Maybe<Scalars['Float']['output']>;
  courierName?: Maybe<Scalars['String']['output']>;
  courierPhone?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deliveredAt?: Maybe<Scalars['DateTime']['output']>;
  eta?: Maybe<Scalars['String']['output']>;
  etaMinutes?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Float']['output'];
  locationUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  merchantOrderId?: Maybe<Scalars['String']['output']>;
  order: Order;
  pickedAt?: Maybe<Scalars['DateTime']['output']>;
  remoteOrderId?: Maybe<Scalars['String']['output']>;
  returnedAt?: Maybe<Scalars['DateTime']['output']>;
  status: MrMandoobOrderStatus;
  updatedAt: Scalars['DateTime']['output'];
};

/** Mr Mandoob logistics status: new, accepted, arrived_to_store, picked, delivered, cancelled, returned */
export enum MrMandoobOrderStatus {
  Accepted = 'ACCEPTED',
  ArrivedToStore = 'ARRIVED_TO_STORE',
  Cancelled = 'CANCELLED',
  Delivered = 'DELIVERED',
  New = 'NEW',
  Picked = 'PICKED',
  Returned = 'RETURNED'
}

export type MrMandoobOrderStatusResultModel = {
  __typename?: 'MrMandoobOrderStatusResultModel';
  orderStatus: Scalars['String']['output'];
  timeline: Array<MrMandoobOrderTimelineEntryModel>;
};

export type MrMandoobOrderTimelineEntryModel = {
  __typename?: 'MrMandoobOrderTimelineEntryModel';
  date: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

/** Mr Mandoob vehicle type: CAR = 1, MOTORBIKE = 3 */
export enum MrMandoobVehicleType {
  Car = 'CAR',
  Motorbike = 'MOTORBIKE'
}

export type Mutation = {
  __typename?: 'Mutation';
  acceptInvitation: AcceptInvitationResponse;
  activateProductOptionCategories: Scalars['Boolean']['output'];
  activateProductOptions: Scalars['Boolean']['output'];
  activateProducts: Scalars['Boolean']['output'];
  activateProductsForStore: Scalars['Boolean']['output'];
  activateStores: Scalars['Boolean']['output'];
  /** Create a new ledger transaction with optional media attachment (Admin only) */
  addLedgerTransaction: LedgerTransaction;
  /** ADMIN ONLY: Assign an approved driver to an unassigned order and notify the driver/customers. */
  adminAssignDriverToOrder: Order;
  /** ADMIN ONLY: Cancel an order, refund payment when possible, and notify related users. */
  adminCancelOrder: Order;
  /** ADMIN ONLY: Requires password; rate limited (few calls per hour per client). Permanently deletes all commerce data (sessions through ledger), all driver withdrawals and beneficiaries, clears every activeAddressId and deletes every address row, deletes all refresh_tokens, audit_logs, and webhook_logs; then integration logs / permission overrides and related rows for removable users, and hard-deletes users whose roles include neither admin nor partner. Keeps admins and partners regardless of extra roles (e.g. customer+partner). Disabled in production. Irreversible. */
  adminHardPurgeAllCommerceData: CommerceDataPurgeResult;
  /** ADMIN ONLY: Requires password; rate limited (few calls per hour per client). Looks up a DRIVER by phone number and permanently deletes that driver: onboarding docs, withdrawals, transactions, order requests, tokens, addresses, Nafath rows, and the user. Unassigns the driver from orders (does not delete customer orders). Enqueues Tawseel deactivateDriver when an idNumber exists. Irreversible. */
  adminHardPurgeDriverByPhone: AdminPurgeDriverByPhoneResult;
  /** ADMIN ONLY: Requires password. Runs a full "logistics happy path" with dummy data: create a dummy driver (user + driverInfo + identity + vehicle registration), enqueue Tawseel createDriver, create a seeded flash-sale order, accept it, assign it to the driver, then PICKED_UP -> ARRIVED_AT_CUSTOMER -> DELIVERED. Disabled in production. */
  adminRunDummyLogisticsFlowV1: AdminRunLogisticsFlowResult;
  /** ADMIN ONLY: Requires password. Creates up to `limit` in-progress flash-sale sessions near `coordinate` (host order + cart + payment + order) so they appear in getNearbyFlashSalesV4 at that location. Host users: ADMIN_FLASH_SALE_SEED_HOST_USER_IDS or first available customer accounts. Disabled in production. */
  adminSeedNearbyFlashSalesV4: AdminSeedNearbyFlashSalesResult;
  /** ADMIN ONLY: Disabled in production. Send a partner new-order data-only push notification directly to an FCM token using dummy order payload data. */
  adminSendStoreOrderSoundNotification: NotificationResponse;
  appLogin: AppLoginResponse;
  applyPromoCodeToSession: ShoppingSession;
  cancelOrder: Order;
  /** Cancel a pending withdrawal request */
  cancelWithdrawal: DriverWithdrawal;
  changeOrderStatus: Order;
  checkout: Payment;
  /** Clean up expired files */
  cleanupExpiredFiles: Scalars['Float']['output'];
  clearMyCart: Scalars['Boolean']['output'];
  confirmOrder: Order;
  createAddress: Address;
  createBeneficiary: Beneficiary;
  /** Create a withdrawal request. Amount must be less than or equal to driver balance. */
  createDriverWithdrawal: DriverWithdrawal;
  /** Create a new finance tree item */
  createFinanceTreeItem: FinanceTree;
  /** Create a new finance tree transaction */
  createFinanceTreeTransaction: FinanceTreeTransaction;
  createNafathVerification: NafathVerification;
  createPartner: Partner;
  createPartnerCategory: PartnerCategory;
  createPermission: Permission;
  createPlan: Plan;
  createProduct: Product;
  createProductCategory: ProductCategory;
  createProductOptionCategory: ProductOptionCategory;
  createPromoCode: PromoCode;
  createStore: Store;
  createTransactionCategory: TransactionCategory;
  createWorkingHours: WorkingHours;
  deactivateDeviceToken: DeviceTokenResponse;
  deactivateProductOptionCategories: Scalars['Boolean']['output'];
  deactivateProductOptions: Scalars['Boolean']['output'];
  deactivateProducts: Scalars['Boolean']['output'];
  deactivateProductsForStore: Scalars['Boolean']['output'];
  /** Deactivate a saved card - removes it from HyperPay and deletes from database */
  deactivateSavedCard: Scalars['Boolean']['output'];
  deactivateStores: Scalars['Boolean']['output'];
  deleteAddress: Scalars['Boolean']['output'];
  deleteBeneficiary: Scalars['Boolean']['output'];
  deleteDeviceToken: DeviceTokenResponse;
  /** Delete a finance tree item (soft delete) */
  deleteFinanceTreeItem: Scalars['Boolean']['output'];
  /** Delete a finance tree transaction (soft delete) */
  deleteFinanceTreeTransaction: Scalars['Boolean']['output'];
  /** Delete a media file */
  deleteMedia: Scalars['Boolean']['output'];
  deleteMySession: Scalars['Boolean']['output'];
  deletePartner: Scalars['Boolean']['output'];
  deletePartnerCategory: Scalars['Boolean']['output'];
  deletePermission: Scalars['Boolean']['output'];
  deletePlan: Scalars['Boolean']['output'];
  deleteProduct: Scalars['Boolean']['output'];
  deleteProductCategory: Scalars['Boolean']['output'];
  deleteProductOptionCategory: Scalars['Boolean']['output'];
  deleteProductPrice: Scalars['Boolean']['output'];
  deletePromoCode: Scalars['Boolean']['output'];
  deleteStore: Scalars['Boolean']['output'];
  deleteTransactionCategory: Scalars['Boolean']['output'];
  deleteWorkingHours: Scalars['Boolean']['output'];
  /** Register delivery driver with OTP verification */
  deliveryLogin: DeliveryLoginResponse;
  /** Logout driver - only invalidates driver session, keeps customer session active if user has both roles */
  driverLogout: Scalars['Boolean']['output'];
  forgotPassword: Scalars['String']['output'];
  /** Get the current location for the authenticated driver (from Redis). Returns null if not set/expired. */
  getMyCurrentLocation?: Maybe<DriverCurrentLocation>;
  hardRefreshPayment: Payment;
  /** TEST ONLY (removable): ADMIN — Requires password. Captures (CP) a pre-authorized HyperPay payment. */
  hyperpayCapturePayment: HyperpayApiMutationResult;
  /** TEST ONLY (removable): ADMIN — Requires password. Creates a HyperPay checkout session (default flow PA, currency SAR). */
  hyperpayCreateCheckout: HyperpayApiMutationResult;
  /** TEST ONLY (removable): ADMIN — Requires password. Fetches HyperPay checkout/payment status for a checkout id. */
  hyperpayGetCheckoutStatus: HyperpayApiMutationResult;
  /** TEST ONLY (removable): ADMIN — Requires password. Reverses (RV) a pre-authorized HyperPay payment. */
  hyperpayReversePayment: HyperpayApiMutationResult;
  invitePartnerUser: Scalars['String']['output'];
  inviteUserForPartner: Scalars['String']['output'];
  joinSession: Scalars['Boolean']['output'];
  leaveSession: Scalars['Boolean']['output'];
  linkDeviceTokenToUser: DeviceTokenResponse;
  logout: Scalars['Boolean']['output'];
  logoutFromAllDevices: Scalars['Float']['output'];
  markOrderReadyForPickup: Order;
  portalLogin: AuthResponse;
  postMySession: Scalars['Boolean']['output'];
  refreshToken: RefreshResponse;
  registerDeviceToken: DeviceTokenResponse;
  removeMyDeviceTokens: DeviceTokenResponse;
  removePromoCodeFromSession: ShoppingSession;
  removeUserForPartner: User;
  resetPassword: Scalars['Boolean']['output'];
  saveDeliverySettings: DeliverySetting;
  saveGoogleMapsRushHours: GoogleMapsRushHours;
  saveOrderChatwootId: Order;
  saveOrderChatwootStoreConversationId: Order;
  saveStoreChatwootConversationId: Store;
  saveStoreChatwootSourceId: Store;
  saveSystemConfiguration: SystemConfiguration;
  saveUserChatwootCustomerConversationId: User;
  saveUserChatwootDriverConversationId: User;
  saveUserChatwootId: User;
  saveUserChatwootPartnerConversationId: User;
  /** Send OTP for delivery driver registration */
  sendDeliveryOTP: Scalars['Boolean']['output'];
  sendHelloMessage: NotificationResponse;
  sendMultipleNotifications: BatchNotificationResponse;
  sendNotification: NotificationResponse;
  sendNotificationToUser: BatchNotificationResponse;
  sendOTP: Scalars['Boolean']['output'];
  sendTopicNotification: NotificationResponse;
  setActiveAddress: Scalars['Boolean']['output'];
  setMaintenanceMode: MaintenanceStatus;
  setStoreProductOutOfStock: Product;
  setStoreTemporaryClosure: Store;
  /** TEST ONLY (ADMIN): Disabled in production. Creates a Logisti driver, then a Makkah order when the driver is accepted, then accepts or rejects that order. ACCEPT also assigns the created driver and executes the order. paymentMethodId stays Nap4gA1tyeY=. Pass decision ACCEPT or REJECT. Driver identityTypeId, regionId, and cityId stay fixed. Order authorityId and categoryId stay fixed, and regionId and cityId match the driver. */
  simulateTawseelDriverTrip: TawseelDriverTripSimulationResult;
  startPreparingOrder: Order;
  /** Partner app heartbeat — proves the store device has working internet */
  storeHeartbeat: Scalars['Boolean']['output'];
  storeLogin: AuthResponse;
  /** Submit identity document (ID card) */
  submitDriverIdentity: DriverIdentity;
  /** Submit driver detailed information */
  submitDriverInfo: DriverInfo;
  /** Submit driver's license document */
  submitDriverLicense: DriverLicense;
  /** Submit profile picture (selfie) */
  submitDriverProfilePicture: DriverProfilePicture;
  /** Submit vehicle registration document */
  submitDriverVehicleRegistration: DriverVehicleRegistration;
  subscribeToTopic: TopicManagementResponse;
  /** Switch auto-accept order request on or off for the authenticated driver */
  switchAutoAcceptOrderRequest: Scalars['Boolean']['output'];
  /** Test: Enqueue Tawseel createDriver for a user (driver). Use for debugging. */
  tawseelTestCreateDriver: TawseelTestResponse;
  /** Test: Enqueue Tawseel createOrder+acceptOrder for an order. Use for debugging. */
  tawseelTestEnqueueAcceptOrder: TawseelQueuedResponse;
  /** Test: Enqueue Tawseel createOrder for an order. Use for debugging. */
  tawseelTestEnqueueCreateOrder: TawseelQueuedResponse;
  /** Test: Enqueue Tawseel rejectOrder for an order. Use for debugging. */
  tawseelTestEnqueueRejectOrder: TawseelQueuedResponse;
  /** Test: Notify the nearest eligible free driver for an order. Use for debugging. */
  tawseelTestNotifyNearestEligibleDriverForOrder: TawseelTestResponse;
  /** TEST ONLY (ADMIN): Disabled in production. Mark the order subtree READY_FOR_PICKUP, unset driverId (set driverId = null) for the order subtree, and hard-delete all related driver order requests. */
  testDetachOrderAndClearDriverRequests: Scalars['Boolean']['output'];
  /** TEST ONLY (ADMIN): Disabled in production. Mark ALL orders as DELIVERED and mark ALL driver order requests as COMPLETED. */
  testMarkAllOrdersDeliveredAndCompleteAllDriverRequests: Scalars['Boolean']['output'];
  /** TEST ONLY (ADMIN): Disabled in production. Create a Mr Mandoob logistics order (POST /api/external/v1/add-order). */
  testMrMandoobAddOrder: MrMandoobAddOrderResultModel;
  /** TEST ONLY (ADMIN): Disabled in production. Cancel a Mr Mandoob order. Allowed statuses: new, accepted. */
  testMrMandoobCancelOrder: MrMandoobMutationResultModel;
  /** TEST ONLY (ADMIN): Disabled in production. Return a Mr Mandoob order to sender. Allowed status: arrived_to_store. */
  testMrMandoobReturnOrder: MrMandoobMutationResultModel;
  /** TEST ONLY (ADMIN): Disabled in production. Set all APPROVED drivers to AVAILABLE (online) and place them evenly on a 50m circle around the given coordinates. */
  testSetAllApprovedDriversOnline: Scalars['Int']['output'];
  toggleCartReady: Scalars['Boolean']['output'];
  touchOrderStoreConversation: Order;
  unsubscribeFromTopic: TopicManagementResponse;
  updateAddress: Address;
  updateBeneficiary: Beneficiary;
  updateBeneficiaryStatus: Beneficiary;
  updateChatwootDriverConversationId: Order;
  /** Update driver document status by document type */
  updateDriverDocumentStatus?: Maybe<DriverDocument>;
  updateDriverOrderRequestStatus: UpdateDriverOrderRequestStatusResponse;
  /** Update driver registration status by userId */
  updateDriverStatusByUserId: DriverInfo;
  /** Update a finance tree item */
  updateFinanceTreeItem: FinanceTree;
  /** Update a finance tree transaction */
  updateFinanceTreeTransaction: FinanceTreeTransaction;
  updateMyCart: Cart;
  /** Update the current coordinates for the authenticated driver (stored in Redis GEO) */
  updateMyLocation: Scalars['Boolean']['output'];
  updateMyPartner: Partner;
  updateMyPassword: User;
  updateMySession: Scalars['Boolean']['output'];
  /** Update the current status for the authenticated driver (available/busy/offline) */
  updateMyStatus: Scalars['Boolean']['output'];
  updateMyUser: User;
  updateMyUsername: User;
  updateOrderDriverLocation: Scalars['Boolean']['output'];
  updateOrderStatus: Order;
  updatePartner: Partner;
  updatePartnerCategory: PartnerCategory;
  updatePermission: Permission;
  updatePlan: Plan;
  updateProduct: Product;
  updateProductCategory: ProductCategory;
  updateProductOptionCategory: ProductOptionCategory;
  updatePromoCode: PromoCode;
  updateStore: Scalars['Boolean']['output'];
  updateTransactionCategory: TransactionCategory;
  /** Update withdrawal status (admin only) */
  updateWithdrawalStatus: DriverWithdrawal;
  updateWorkingHours: WorkingHours;
  /** Upload a file using base64 encoded string */
  uploadFile: Media;
  upsertCartItem: Cart;
  upsertMyShoppingSession: ShoppingSession;
  validateInvitation: Scalars['Boolean']['output'];
};


export type MutationAcceptInvitationArgs = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationActivateProductOptionCategoriesArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type MutationActivateProductOptionsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type MutationActivateProductsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type MutationActivateProductsForStoreArgs = {
  ids: Array<Scalars['Int']['input']>;
  storeId: Scalars['Int']['input'];
};


export type MutationActivateStoresArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type MutationAddLedgerTransactionArgs = {
  input: CreateLedgerTransactionDto;
};


export type MutationAdminAssignDriverToOrderArgs = {
  driverId: Scalars['Int']['input'];
  orderId: Scalars['Int']['input'];
};


export type MutationAdminCancelOrderArgs = {
  cancellationNote?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['Int']['input'];
};


export type MutationAdminHardPurgeAllCommerceDataArgs = {
  password: Scalars['String']['input'];
};


export type MutationAdminHardPurgeDriverByPhoneArgs = {
  password: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};


export type MutationAdminRunDummyLogisticsFlowV1Args = {
  carNumber?: InputMaybe<Scalars['String']['input']>;
  carTypeId?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  idNumber?: InputMaybe<Scalars['String']['input']>;
  identityTypeId?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  regionId?: InputMaybe<Scalars['String']['input']>;
  vehicleSequenceNumber?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAdminSeedNearbyFlashSalesV4Args = {
  coordinate: CoordinateArgs;
  limit: Scalars['Float']['input'];
  password: Scalars['String']['input'];
};


export type MutationAdminSendStoreOrderSoundNotificationArgs = {
  fcmToken: Scalars['String']['input'];
};


export type MutationAppLoginArgs = {
  appLoginDto: AppLoginDto;
};


export type MutationApplyPromoCodeToSessionArgs = {
  code: Scalars['String']['input'];
};


export type MutationCancelOrderArgs = {
  cancellationNote?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['Int']['input'];
};


export type MutationCancelWithdrawalArgs = {
  withdrawalId: Scalars['Float']['input'];
};


export type MutationChangeOrderStatusArgs = {
  orderId: Scalars['Int']['input'];
};


export type MutationCheckoutArgs = {
  paymentMethodDto?: InputMaybe<PaymentMethodDto>;
};


export type MutationConfirmOrderArgs = {
  orderId: Scalars['Int']['input'];
};


export type MutationCreateAddressArgs = {
  createAddressDto: CreateAddressDto;
};


export type MutationCreateBeneficiaryArgs = {
  input: CreateBeneficiaryDto;
};


export type MutationCreateDriverWithdrawalArgs = {
  input: CreateDriverWithdrawalDto;
};


export type MutationCreateFinanceTreeItemArgs = {
  createFinanceTreeDto: CreateFinanceTreeDto;
};


export type MutationCreateFinanceTreeTransactionArgs = {
  createFinanceTreeTransactionDto: CreateFinanceTreeTransactionDto;
};


export type MutationCreateNafathVerificationArgs = {
  input: CreateNafathRequestDto;
};


export type MutationCreatePartnerArgs = {
  createPartnerDto: CreatePartnerDto;
};


export type MutationCreatePartnerCategoryArgs = {
  createPartnerCategoryDto: CreatePartnerCategoryDto;
};


export type MutationCreatePermissionArgs = {
  createPermissionDto: CreatePermissionDto;
};


export type MutationCreatePlanArgs = {
  createPlanDto: CreatePlanDto;
};


export type MutationCreateProductArgs = {
  createProductDto: CreateProductDto;
};


export type MutationCreateProductCategoryArgs = {
  createProductCategoryDto: CreateProductCategoryDto;
};


export type MutationCreateProductOptionCategoryArgs = {
  createProductOptionCategoryDto: CreateProductOptionCategoryDto;
};


export type MutationCreatePromoCodeArgs = {
  createPromoCodeDto: CreatePromoCodeDto;
};


export type MutationCreateStoreArgs = {
  createStoreDto: CreateStoreDto;
};


export type MutationCreateTransactionCategoryArgs = {
  input: CreateTransactionCategoryInput;
};


export type MutationCreateWorkingHoursArgs = {
  createWorkingHoursDto: CreateWorkingHoursDto;
};


export type MutationDeactivateDeviceTokenArgs = {
  token: Scalars['String']['input'];
};


export type MutationDeactivateProductOptionCategoriesArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type MutationDeactivateProductOptionsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type MutationDeactivateProductsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type MutationDeactivateProductsForStoreArgs = {
  ids: Array<Scalars['Int']['input']>;
  storeId: Scalars['Int']['input'];
};


export type MutationDeactivateSavedCardArgs = {
  cardId: Scalars['Int']['input'];
};


export type MutationDeactivateStoresArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type MutationDeleteAddressArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteBeneficiaryArgs = {
  input: DeleteBeneficiaryDto;
};


export type MutationDeleteDeviceTokenArgs = {
  token: Scalars['String']['input'];
};


export type MutationDeleteFinanceTreeItemArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteFinanceTreeTransactionArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteMediaArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeletePartnerArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeletePartnerCategoryArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeletePermissionArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeletePlanArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteProductArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteProductCategoryArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteProductOptionCategoryArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteProductPriceArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeletePromoCodeArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteStoreArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteTransactionCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteWorkingHoursArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeliveryLoginArgs = {
  data: RegisterDeliveryDto;
};


export type MutationDriverLogoutArgs = {
  deviceToken?: InputMaybe<Scalars['String']['input']>;
  refreshToken: Scalars['String']['input'];
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String']['input'];
};


export type MutationHardRefreshPaymentArgs = {
  ref: Scalars['String']['input'];
};


export type MutationHyperpayCapturePaymentArgs = {
  amount: Scalars['Float']['input'];
  applePay?: Scalars['Boolean']['input'];
  password: Scalars['String']['input'];
  paymentId: Scalars['String']['input'];
};


export type MutationHyperpayCreateCheckoutArgs = {
  applePay?: Scalars['Boolean']['input'];
  flowType?: PaymentFlowType;
  password: Scalars['String']['input'];
  price: Scalars['Float']['input'];
};


export type MutationHyperpayGetCheckoutStatusArgs = {
  applePay?: Scalars['Boolean']['input'];
  checkoutId: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationHyperpayReversePaymentArgs = {
  amount: Scalars['Float']['input'];
  applePay?: Scalars['Boolean']['input'];
  password: Scalars['String']['input'];
  paymentId: Scalars['String']['input'];
};


export type MutationInvitePartnerUserArgs = {
  createPartnerInvitationDto: CreatePartnerInvitationDto;
  partnerId: Scalars['Int']['input'];
};


export type MutationInviteUserForPartnerArgs = {
  createPartnerInvitationDto: CreatePartnerInvitationDto;
};


export type MutationJoinSessionArgs = {
  joinSessionInput: JoinSessionDto;
};


export type MutationLinkDeviceTokenToUserArgs = {
  token: Scalars['String']['input'];
};


export type MutationLogoutArgs = {
  deviceToken?: InputMaybe<Scalars['String']['input']>;
  refreshToken: Scalars['String']['input'];
};


export type MutationMarkOrderReadyForPickupArgs = {
  orderId: Scalars['Int']['input'];
};


export type MutationPortalLoginArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationRefreshTokenArgs = {
  refreshToken: Scalars['String']['input'];
};


export type MutationRegisterDeviceTokenArgs = {
  input: RegisterDeviceTokenInput;
};


export type MutationRemoveUserForPartnerArgs = {
  id: Scalars['Int']['input'];
};


export type MutationResetPasswordArgs = {
  newPassword: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationSaveDeliverySettingsArgs = {
  saveDeliverySettingDto: SaveDeliverySettingDto;
};


export type MutationSaveGoogleMapsRushHoursArgs = {
  saveGoogleMapsRushHoursDto: SaveGoogleMapsRushHoursDto;
};


export type MutationSaveOrderChatwootIdArgs = {
  conversationId: Scalars['String']['input'];
  orderId: Scalars['Int']['input'];
};


export type MutationSaveOrderChatwootStoreConversationIdArgs = {
  conversationId: Scalars['String']['input'];
  orderId: Scalars['Int']['input'];
};


export type MutationSaveStoreChatwootConversationIdArgs = {
  conversationId: Scalars['String']['input'];
};


export type MutationSaveStoreChatwootSourceIdArgs = {
  sourceId: Scalars['String']['input'];
};


export type MutationSaveSystemConfigurationArgs = {
  saveSystemConfigurationDto: SaveSystemConfigurationDto;
};


export type MutationSaveUserChatwootCustomerConversationIdArgs = {
  conversationId: Scalars['String']['input'];
};


export type MutationSaveUserChatwootDriverConversationIdArgs = {
  conversationId: Scalars['String']['input'];
};


export type MutationSaveUserChatwootIdArgs = {
  sourceId: Scalars['String']['input'];
};


export type MutationSaveUserChatwootPartnerConversationIdArgs = {
  conversationId: Scalars['String']['input'];
};


export type MutationSendDeliveryOtpArgs = {
  data: SendDeliveryOtpDto;
};


export type MutationSendHelloMessageArgs = {
  input: SendHelloMessageInput;
};


export type MutationSendMultipleNotificationsArgs = {
  input: SendMultipleNotificationsInput;
};


export type MutationSendNotificationArgs = {
  input: SendNotificationInput;
};


export type MutationSendNotificationToUserArgs = {
  input: SendNotificationToUserInput;
};


export type MutationSendOtpArgs = {
  data: SendOtpDto;
};


export type MutationSendTopicNotificationArgs = {
  input: SendTopicNotificationInput;
};


export type MutationSetActiveAddressArgs = {
  addressId: Scalars['Int']['input'];
};


export type MutationSetMaintenanceModeArgs = {
  input: SetMaintenanceInput;
};


export type MutationSetStoreProductOutOfStockArgs = {
  id: Scalars['Int']['input'];
  input: CreateOutOfStockDto;
};


export type MutationSetStoreTemporaryClosureArgs = {
  id: Scalars['Int']['input'];
  input: CreateTemporarilyClosedDto;
};


export type MutationSimulateTawseelDriverTripArgs = {
  decision: TawseelTripOrderDecision;
};


export type MutationStartPreparingOrderArgs = {
  orderId: Scalars['Int']['input'];
};


export type MutationStoreHeartbeatArgs = {
  storeId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationStoreLoginArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationSubmitDriverIdentityArgs = {
  data: CreateDriverIdentityDto;
};


export type MutationSubmitDriverInfoArgs = {
  data: CreateDriverInfoDto;
};


export type MutationSubmitDriverLicenseArgs = {
  data: CreateDriverLicenseDto;
};


export type MutationSubmitDriverProfilePictureArgs = {
  data: CreateDriverProfilePictureDto;
};


export type MutationSubmitDriverVehicleRegistrationArgs = {
  data: CreateDriverVehicleRegistrationDto;
};


export type MutationSubscribeToTopicArgs = {
  input: ManageTopicInput;
};


export type MutationSwitchAutoAcceptOrderRequestArgs = {
  autoAcceptOrderRequest: Scalars['Boolean']['input'];
};


export type MutationTawseelTestCreateDriverArgs = {
  userId: Scalars['Int']['input'];
};


export type MutationTawseelTestEnqueueAcceptOrderArgs = {
  orderId: Scalars['Int']['input'];
};


export type MutationTawseelTestEnqueueCreateOrderArgs = {
  orderId: Scalars['Int']['input'];
};


export type MutationTawseelTestEnqueueRejectOrderArgs = {
  orderId: Scalars['Int']['input'];
};


export type MutationTawseelTestNotifyNearestEligibleDriverForOrderArgs = {
  orderId: Scalars['Int']['input'];
};


export type MutationTestDetachOrderAndClearDriverRequestsArgs = {
  orderId: Scalars['Int']['input'];
};


export type MutationTestMrMandoobAddOrderArgs = {
  input: AddMrMandoobOrderDto;
};


export type MutationTestMrMandoobCancelOrderArgs = {
  input: CancelMrMandoobOrderDto;
};


export type MutationTestMrMandoobReturnOrderArgs = {
  input: ReturnMrMandoobOrderDto;
};


export type MutationTestSetAllApprovedDriversOnlineArgs = {
  coordinates: CoordinateArgs;
};


export type MutationTouchOrderStoreConversationArgs = {
  orderId: Scalars['Int']['input'];
};


export type MutationUnsubscribeFromTopicArgs = {
  input: ManageTopicInput;
};


export type MutationUpdateAddressArgs = {
  id: Scalars['Int']['input'];
  updateAddressDto: UpdateAddressDto;
};


export type MutationUpdateBeneficiaryArgs = {
  input: UpdateBeneficiaryDto;
};


export type MutationUpdateBeneficiaryStatusArgs = {
  input: UpdateBeneficiaryStatusDto;
};


export type MutationUpdateChatwootDriverConversationIdArgs = {
  input: UpdateChatwootDriverConversationDto;
};


export type MutationUpdateDriverDocumentStatusArgs = {
  input: UpdateDriverDocumentStatusDto;
  userId: Scalars['Int']['input'];
};


export type MutationUpdateDriverOrderRequestStatusArgs = {
  input: UpdateDriverOrderRequestStatusDto;
};


export type MutationUpdateDriverStatusByUserIdArgs = {
  input: UpdateDriverStatusDto;
};


export type MutationUpdateFinanceTreeItemArgs = {
  id: Scalars['Int']['input'];
  updateFinanceTreeDto: UpdateFinanceTreeDto;
};


export type MutationUpdateFinanceTreeTransactionArgs = {
  id: Scalars['Int']['input'];
  updateFinanceTreeTransactionDto: UpdateFinanceTreeTransactionDto;
};


export type MutationUpdateMyCartArgs = {
  updateCart: UpdateCartDto;
};


export type MutationUpdateMyLocationArgs = {
  coordinates: CoordinateArgs;
};


export type MutationUpdateMyPartnerArgs = {
  updatePartnerDto: UpdatePartnerDto;
};


export type MutationUpdateMyPasswordArgs = {
  newPassword: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
};


export type MutationUpdateMySessionArgs = {
  updateShoppingSessionStatusInput: UpdateShoppingSessionStatusInput;
};


export type MutationUpdateMyStatusArgs = {
  status: DriverStatus;
};


export type MutationUpdateMyUserArgs = {
  updateUserDto: UpdateUserDto;
};


export type MutationUpdateMyUsernameArgs = {
  updateUserNameDto: UpdateUserNameDto;
};


export type MutationUpdateOrderDriverLocationArgs = {
  coordinates: CoordinateArgs;
  orderId: Scalars['Int']['input'];
};


export type MutationUpdateOrderStatusArgs = {
  input: UpdateOrderStatusDto;
};


export type MutationUpdatePartnerArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  updatePartnerDto: UpdatePartnerDto;
};


export type MutationUpdatePartnerCategoryArgs = {
  id: Scalars['Int']['input'];
  updatePartnerCategoryDto: UpdatePartnerCategoryDto;
};


export type MutationUpdatePermissionArgs = {
  id: Scalars['Int']['input'];
  updatePermissionDto: UpdatePermissionDto;
};


export type MutationUpdatePlanArgs = {
  id: Scalars['Int']['input'];
  updatePlanDto: UpdatePlanDto;
};


export type MutationUpdateProductArgs = {
  id: Scalars['Int']['input'];
  updateProductDto: UpdateProductDto;
};


export type MutationUpdateProductCategoryArgs = {
  id: Scalars['Int']['input'];
  updateProductCategoryDto: UpdateProductCategoryDto;
};


export type MutationUpdateProductOptionCategoryArgs = {
  id: Scalars['Int']['input'];
  updateProductOptionCategoryDto: UpdateProductOptionCategoryDto;
};


export type MutationUpdatePromoCodeArgs = {
  id: Scalars['Int']['input'];
  updatePromoCodeDto: UpdatePromoCodeDto;
};


export type MutationUpdateStoreArgs = {
  id: Scalars['Int']['input'];
  updateStoreDto: UpdateStoreDto;
};


export type MutationUpdateTransactionCategoryArgs = {
  input: UpdateTransactionCategoryInput;
};


export type MutationUpdateWithdrawalStatusArgs = {
  input: UpdateWithdrawalStatusDto;
};


export type MutationUpdateWorkingHoursArgs = {
  id: Scalars['Int']['input'];
  updateWorkingHoursDto: UpdateWorkingHoursDto;
};


export type MutationUploadFileArgs = {
  altText?: InputMaybe<Scalars['String']['input']>;
  base64File: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  folder?: InputMaybe<Scalars['String']['input']>;
  originalName: Scalars['String']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationUpsertCartItemArgs = {
  upsertCartItem: UpsertCartItem;
};


export type MutationUpsertMyShoppingSessionArgs = {
  confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  createShoppingSessionDto: CreateShoppingSessionDto;
};


export type MutationValidateInvitationArgs = {
  token: Scalars['String']['input'];
};

/** Current status of a Nafath verification request */
export enum NafathRequestStatus {
  Completed = 'COMPLETED',
  Expired = 'EXPIRED',
  Rejected = 'REJECTED',
  Waiting = 'WAITING'
}

/** Nafath verification service type */
export enum NafathServiceType {
  Login = 'LOGIN',
  ReactivateAccount = 'REACTIVATE_ACCOUNT',
  UserVerification = 'USER_VERIFICATION'
}

export type NafathVerification = {
  __typename?: 'NafathVerification';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deviceId?: Maybe<Scalars['String']['output']>;
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  imei?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  nationalId: Scalars['String']['output'];
  random?: Maybe<Scalars['String']['output']>;
  requestId: Scalars['String']['output'];
  service: NafathServiceType;
  status: NafathRequestStatus;
  tokenPayload?: Maybe<Scalars['JSON']['output']>;
  transId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userId?: Maybe<Scalars['Float']['output']>;
};

export type NearbyDriver = {
  __typename?: 'NearbyDriver';
  distanceKm: Scalars['Float']['output'];
  driverId: Scalars['Int']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type NearbyStoreDeliveryPlan = {
  __typename?: 'NearbyStoreDeliveryPlan';
  afterDiscountDeliveryFeeForScheduled?: Maybe<Scalars['Float']['output']>;
  afterDiscountDeliveryFeeForSmart?: Maybe<Scalars['Float']['output']>;
  afterDiscountDeliveryFeeForUrgent?: Maybe<Scalars['Float']['output']>;
  defaultDeliveryFee: Scalars['Float']['output'];
};

export type NotificationResponse = {
  __typename?: 'NotificationResponse';
  message?: Maybe<Scalars['String']['output']>;
  messageId: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type Order = {
  __typename?: 'Order';
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  actualPreparationTimeMinutes?: Maybe<Scalars['Float']['output']>;
  additionalCustomerFee?: Maybe<Scalars['Float']['output']>;
  address: Address;
  addressCoordinates: Scalars['String']['output'];
  afterDiscountDeliveryFee: Scalars['Float']['output'];
  arrivedAtCustomerAt?: Maybe<Scalars['DateTime']['output']>;
  cancellationNote?: Maybe<Scalars['String']['output']>;
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  chatwootConversationId?: Maybe<Scalars['String']['output']>;
  chatwootDriverConversationId?: Maybe<Scalars['String']['output']>;
  chatwootStoreConversationId?: Maybe<Scalars['String']['output']>;
  children?: Maybe<Array<Order>>;
  createdAt: Scalars['DateTime']['output'];
  defaultDeliveryFee?: Maybe<Scalars['Float']['output']>;
  deliveredAt?: Maybe<Scalars['DateTime']['output']>;
  deliveryFeeDiscountAmount: Scalars['Float']['output'];
  deliveryFleet?: Maybe<DeliveryFleet>;
  deliveryInstructions?: Maybe<Scalars['String']['output']>;
  deliveryPosition: Scalars['Int']['output'];
  deliveryProofMedia?: Maybe<Media>;
  discountAmount: Scalars['Float']['output'];
  discountMinimumCartAmount?: Maybe<Scalars['Float']['output']>;
  discountPartnerCoverageAmount?: Maybe<Scalars['Float']['output']>;
  discountRate?: Maybe<Scalars['Float']['output']>;
  driver?: Maybe<User>;
  driverId?: Maybe<Scalars['Int']['output']>;
  duePaymentAmount?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Float']['output'];
  isFlashSale: Scalars['Boolean']['output'];
  items: Array<OrderItem>;
  minimumCartForFreeDelivery?: Maybe<Scalars['Float']['output']>;
  mrMandoobRequest?: Maybe<MrMandoobOrderRequest>;
  ownDriverMissCount: Scalars['Int']['output'];
  parent?: Maybe<Order>;
  parentId?: Maybe<Scalars['Int']['output']>;
  partner: Partner;
  partnerDeliveryCoverageAmount?: Maybe<Scalars['Float']['output']>;
  payment?: Maybe<Payment>;
  pickedUpAt?: Maybe<Scalars['DateTime']['output']>;
  platformCommission?: Maybe<Scalars['Float']['output']>;
  preparingAt?: Maybe<Scalars['DateTime']['output']>;
  /** Promo code applied to this order */
  promoCode?: Maybe<Scalars['String']['output']>;
  /** Promo code discount applied on top of the plan discount */
  promoDiscountAmount?: Maybe<Scalars['Float']['output']>;
  readyForPickupAt?: Maybe<Scalars['DateTime']['output']>;
  rejectedAt?: Maybe<Scalars['DateTime']['output']>;
  request?: Maybe<DriverOrderRequest>;
  requestId?: Maybe<Scalars['Int']['output']>;
  scheduledAt: Scalars['DateTime']['output'];
  shoppingSession: ShoppingSession;
  startingTimeForPreparing?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
  store: Store;
  storeAddressCoordinates: Scalars['String']['output'];
  storeChatLastMessageAt?: Maybe<Scalars['DateTime']['output']>;
  storeName: Scalars['String']['output'];
  storeNameAr: Scalars['String']['output'];
  subtotalAmount: Scalars['Float']['output'];
  tawseelReferenceCode?: Maybe<Scalars['String']['output']>;
  tip?: Maybe<Scalars['Float']['output']>;
  totalAmount: Scalars['Float']['output'];
  transactions?: Maybe<Array<LedgerTransaction>>;
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  userPhoneNumber: Scalars['String']['output'];
  waitingRestaurantAt?: Maybe<Scalars['DateTime']['output']>;
  waitingScheduledAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OrderDriverLocationUpdate = {
  __typename?: 'OrderDriverLocationUpdate';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  /** The main order id for this delivery (parent id or self) */
  mainOrderId: Scalars['Int']['output'];
  /** Full order details with all relations */
  order?: Maybe<Order>;
  /** The specific order id (main or child) */
  orderId: Scalars['Int']['output'];
  /** Timestamp when the driver location was updated */
  updatedAt: Scalars['DateTime']['output'];
};

export type OrderFilterInput = {
  createdAfter?: InputMaybe<Scalars['DateTime']['input']>;
  createdBefore?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  orderType?: InputMaybe<ShoppingSessionType>;
  status?: InputMaybe<OrderStatus>;
  storeId?: InputMaybe<Scalars['Int']['input']>;
};

export type OrderItem = {
  __typename?: 'OrderItem';
  createdAt: Scalars['DateTime']['output'];
  discountAmount: Scalars['Float']['output'];
  foodQualityTimeMinutes: Scalars['Int']['output'];
  id: Scalars['Float']['output'];
  note?: Maybe<Scalars['String']['output']>;
  optionLabels: Array<Scalars['String']['output']>;
  optionLabelsAr: Array<Scalars['String']['output']>;
  optionPrices?: Maybe<Array<Scalars['Float']['output']>>;
  options?: Maybe<Array<ProductOption>>;
  order: Order;
  product: Product;
  productImageUrl?: Maybe<Scalars['String']['output']>;
  productName: Scalars['String']['output'];
  productNameAr: Scalars['String']['output'];
  productPrice: Scalars['Float']['output'];
  quantity: Scalars['Int']['output'];
  subtotalAmount: Scalars['Float']['output'];
  totalAmount: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
};

export type OrderItemOptionDto = {
  __typename?: 'OrderItemOptionDto';
  label: Scalars['String']['output'];
  labelAr: Scalars['String']['output'];
  price: Scalars['Float']['output'];
};

export type OrderStatisticsResponse = {
  __typename?: 'OrderStatisticsResponse';
  averageOrderValue: Scalars['Float']['output'];
  cancellationRate: Scalars['Float']['output'];
  cancelledOrders: Scalars['Int']['output'];
  dailyTrend: Array<DailyOrderTrend>;
  statusBreakdown: Array<StatusBreakdown>;
  topPartners: Array<TopPartner>;
  topStores: Array<TopStore>;
  totalDeliveryFees: Scalars['Float']['output'];
  totalDiscounts: Scalars['Float']['output'];
  totalOrders: Scalars['Int']['output'];
  totalRevenue: Scalars['Float']['output'];
  totalSubtotal: Scalars['Float']['output'];
  totalTips: Scalars['Float']['output'];
};

/** Status of an order */
export enum OrderStatus {
  Accepted = 'ACCEPTED',
  ArrivedAtCustomer = 'ARRIVED_AT_CUSTOMER',
  Cancelled = 'CANCELLED',
  Created = 'CREATED',
  Delivered = 'DELIVERED',
  PickedUp = 'PICKED_UP',
  Preparing = 'PREPARING',
  ReadyForPickup = 'READY_FOR_PICKUP',
  Rejected = 'REJECTED',
  WaitingRestaurant = 'WAITING_RESTAURANT',
  WaitingScheduled = 'WAITING_SCHEDULED'
}

export type OrderWithFinancialDetails = {
  __typename?: 'OrderWithFinancialDetails';
  /** Distance in kilometers (rounded to 2 decimal places) */
  distance?: Maybe<Scalars['Float']['output']>;
  order: Order;
  /** Total restaurant revenue from this order (sum of all transactions, rounded to 2 decimal places) */
  restaurantRevenue: Scalars['Float']['output'];
  transactions: Array<LedgerTransaction>;
};

export type OrderWithGroupedItems = {
  __typename?: 'OrderWithGroupedItems';
  address: Address;
  addressCoordinates: Scalars['String']['output'];
  afterDiscountDeliveryFee: Scalars['Float']['output'];
  chatwootConversationId?: Maybe<Scalars['String']['output']>;
  chatwootDriverConversationId?: Maybe<Scalars['String']['output']>;
  chatwootStoreConversationId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deliveryInstructions?: Maybe<Scalars['String']['output']>;
  /** Delivery margin in minutes from system configuration */
  deliveryMargin: Scalars['Int']['output'];
  discountAmount: Scalars['Float']['output'];
  driver?: Maybe<InvoiceOrderDriver>;
  duePaymentAmount?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  isFlashSale: Scalars['Boolean']['output'];
  items: Array<GroupedItemsByPhoneDto>;
  itemsCount: Scalars['Int']['output'];
  orderType: ShoppingSessionType;
  partner: Partner;
  payment?: Maybe<Payment>;
  promoCode?: Maybe<Scalars['String']['output']>;
  promoDiscountAmount?: Maybe<Scalars['Float']['output']>;
  scheduleType: ScheduledType;
  scheduledAt: Scalars['DateTime']['output'];
  status: Scalars['String']['output'];
  store: Store;
  storeAddressCoordinates: Scalars['String']['output'];
  storeImage?: Maybe<Scalars['String']['output']>;
  storeName: Scalars['String']['output'];
  storeNameAr: Scalars['String']['output'];
  subtotalAmount: Scalars['Float']['output'];
  tip?: Maybe<Scalars['Float']['output']>;
  totalAmount: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  userPhoneNumber: Scalars['String']['output'];
};

export type PaginatedBeneficiariesResponse = {
  __typename?: 'PaginatedBeneficiariesResponse';
  beneficiaries: Array<Beneficiary>;
  hasMore: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PaginatedDeliveryOrdersResponse = {
  __typename?: 'PaginatedDeliveryOrdersResponse';
  hasMore: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  orders: Array<DeliveryOrderWithStatus>;
  total: Scalars['Int']['output'];
};

export type PaginatedDriversResponse = {
  __typename?: 'PaginatedDriversResponse';
  drivers: Array<User>;
  hasMore: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PaginatedFlashSalesResponse = {
  __typename?: 'PaginatedFlashSalesResponse';
  flashSales: Array<FlashSale_Public>;
  hasMore: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PaginatedFulfillmentRequests = {
  __typename?: 'PaginatedFulfillmentRequests';
  fulfillments: Array<FulfillmentRequest>;
  hasMore: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PaginatedOrdersResponse = {
  __typename?: 'PaginatedOrdersResponse';
  hasMore: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  orders: Array<OrderWithGroupedItems>;
  total: Scalars['Int']['output'];
};

export type PaginatedPartnerOrdersResponse = {
  __typename?: 'PaginatedPartnerOrdersResponse';
  hasMore: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  orders: Array<Order>;
  total: Scalars['Int']['output'];
};

export type PaginatedPartnersResponse = {
  __typename?: 'PaginatedPartnersResponse';
  hasMore: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  partners: Array<Partner>;
  total: Scalars['Int']['output'];
};

export type PaginatedStoresResponse = {
  __typename?: 'PaginatedStoresResponse';
  hasMore: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  stores: Array<Store_Public>;
  total: Scalars['Int']['output'];
};

export type PaginatedWithdrawalsResponse = {
  __typename?: 'PaginatedWithdrawalsResponse';
  hasMore: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  withdrawals: Array<DriverWithdrawal>;
};

export type PaginationInput = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};

export type Partner = {
  __typename?: 'Partner';
  address?: Maybe<Scalars['String']['output']>;
  coverImage?: Maybe<Media>;
  createdAt: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  image?: Maybe<Media>;
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  nameAr: Scalars['String']['output'];
  orders?: Maybe<Order>;
  partnerCategories?: Maybe<Array<PartnerCategory>>;
  partnerCategoriesCount?: Maybe<Scalars['Int']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  plan?: Maybe<Plan>;
  productCategories?: Maybe<Array<ProductCategory>>;
  productImage?: Maybe<Media>;
  productOptionCategories: Array<ProductOptionCategory>;
  products?: Maybe<Array<Product>>;
  stores?: Maybe<Array<Store>>;
  storesCount?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  users?: Maybe<Array<User>>;
  workingHours?: Maybe<Array<WorkingHours>>;
};

export type PartnerBalance = {
  __typename?: 'PartnerBalance';
  partnerId: Scalars['Int']['output'];
  partnerName: Scalars['String']['output'];
  partnerNameAr: Scalars['String']['output'];
  /** Balance breakdown by store */
  storeBalances: Array<StoreBalance>;
  /** Total partner balance as decimal string */
  totalBalance: Scalars['String']['output'];
};

export type PartnerCategory = {
  __typename?: 'PartnerCategory';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  media?: Maybe<Media>;
  name: Scalars['String']['output'];
  nameAr: Scalars['String']['output'];
  partners: Array<Partner>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Determines whether partner discount coverage is a fixed amount or a percentage of the discount */
export enum PartnerCoverageType {
  Amount = 'AMOUNT',
  Rate = 'RATE'
}

export type PartnerDailyTrend = {
  __typename?: 'PartnerDailyTrend';
  date: Scalars['String']['output'];
  deliveryCount: Scalars['Int']['output'];
  totalEarnings: Scalars['Float']['output'];
};

export type PartnerInfo = {
  __typename?: 'PartnerInfo';
  ar: Scalars['String']['output'];
  en: Scalars['String']['output'];
};

export type PartnerPerformance = {
  __typename?: 'PartnerPerformance';
  averageEarningsPerDelivery: Scalars['Float']['output'];
  cancelledDeliveries: Scalars['Int']['output'];
  completedDeliveries: Scalars['Int']['output'];
  completionRate: Scalars['Float']['output'];
  partnerId: Scalars['Int']['output'];
  partnerName: Scalars['String']['output'];
  totalDeliveries: Scalars['Int']['output'];
  totalDeliveryFees: Scalars['Float']['output'];
  totalEarnings: Scalars['Float']['output'];
  totalTips: Scalars['Float']['output'];
};

export type PartnerPromoTracking = {
  __typename?: 'PartnerPromoTracking';
  partner: Partner;
  promoCodes: Array<PromoCode>;
};

export type PartnerStatisticsResponse = {
  __typename?: 'PartnerStatisticsResponse';
  averageEarningsPerDelivery: Scalars['Float']['output'];
  cancelledDeliveries: Scalars['Int']['output'];
  completedDeliveries: Scalars['Int']['output'];
  completionRate: Scalars['Float']['output'];
  dailyTrend: Array<PartnerDailyTrend>;
  topPartners: Array<PartnerPerformance>;
  topStoresByPartner: Array<TopStore>;
  totalDeliveries: Scalars['Int']['output'];
  totalDeliveryFees: Scalars['Float']['output'];
  totalEarnings: Scalars['Float']['output'];
  totalTips: Scalars['Float']['output'];
};

export type Payment = {
  __typename?: 'Payment';
  amount: Scalars['Float']['output'];
  applePay?: Maybe<Scalars['Boolean']['output']>;
  attemptCount: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  errorCode?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  externalRef: Scalars['String']['output'];
  flowType: Scalars['String']['output'];
  id: Scalars['Float']['output'];
  order?: Maybe<Order>;
  orderId?: Maybe<Scalars['ID']['output']>;
  paymentId?: Maybe<Scalars['String']['output']>;
  ref: Scalars['String']['output'];
  saveCard?: Maybe<Scalars['Boolean']['output']>;
  shoppingSession: ShoppingSession;
  shoppingSessionId: Scalars['ID']['output'];
  source: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum PaymentFlowType {
  Cp = 'CP',
  Db = 'DB',
  Pa = 'PA',
  Rf = 'RF',
  Rv = 'RV'
}

export type PaymentMethodDto = {
  applePay?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional saved card ID to use for payment */
  cardId?: InputMaybe<Scalars['Int']['input']>;
  /** Save card for future use */
  saveCard?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Permission = {
  __typename?: 'Permission';
  createdAt: Scalars['DateTime']['output'];
  functions: Array<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  role: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  users?: Maybe<Array<User>>;
};

export type Plan = {
  __typename?: 'Plan';
  commissionRate: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  deliveryPlan?: Maybe<DeliveryPlan>;
  flashSaleDiscounts: Array<FlashSaleDiscount>;
  groupDeliveryDiscounts: Array<GroupDeliveryDiscount>;
  groupOrderDiscounts: Array<GroupOrderDiscount>;
  id: Scalars['Float']['output'];
  individualOrderDiscounts: Array<IndividualOrderDiscount>;
  minCommissionAmount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  partners: Array<Partner>;
  scheduledIndividualOrderDiscounts: Array<ScheduledIndividualOrderDiscount>;
  updatedAt: Scalars['DateTime']['output'];
  urgentIndividualOrderDiscounts: Array<UrgentIndividualOrderDiscount>;
};

export type Price = {
  __typename?: 'Price';
  catItems: Array<CartItem>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  nameAr: Scalars['String']['output'];
  product: Product;
  updatedAt: Scalars['DateTime']['output'];
  value: Scalars['Float']['output'];
};

export type Product = {
  __typename?: 'Product';
  cartItems?: Maybe<CartItem>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  descriptionAr?: Maybe<Scalars['String']['output']>;
  /** Food quality time in minutes */
  foodQualityTimeMinutes: Scalars['Int']['output'];
  id: Scalars['Float']['output'];
  image?: Maybe<Media>;
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  nameAr: Scalars['String']['output'];
  orderItem?: Maybe<OrderItem>;
  partner: Partner;
  price: Scalars['Float']['output'];
  prices: Array<Price>;
  productCategory?: Maybe<ProductCategory>;
  productOptionCategories?: Maybe<Array<ProductOptionCategory>>;
  productStores?: Maybe<Array<ProductStore>>;
  stores: Array<Store>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ProductCategory = {
  __typename?: 'ProductCategory';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  descriptionAr?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  nameAr: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  partner?: Maybe<Partner>;
  products?: Maybe<Array<Product>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ProductCategory_Public = {
  __typename?: 'ProductCategory_Public';
  description?: Maybe<Scalars['String']['output']>;
  descriptionAr?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  nameAr: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  products?: Maybe<Array<Product_Public>>;
};

export type ProductOption = {
  __typename?: 'ProductOption';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  descriptionAr?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  nameAr: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ProductOptionCategory = {
  __typename?: 'ProductOptionCategory';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  descriptionAr?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  isActive: Scalars['Boolean']['output'];
  max: Scalars['Int']['output'];
  min: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  nameAr: Scalars['String']['output'];
  productOptions: Array<ProductOption>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ProductOptionDto = {
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionAr?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  nameAr: Scalars['String']['input'];
  price?: Scalars['Float']['input'];
};

export type ProductStore = {
  __typename?: 'ProductStore';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  outOfStock: Scalars['Boolean']['output'];
  product: Product;
  productId: Scalars['Float']['output'];
  store: Store;
  storeId: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type Product_Public = {
  __typename?: 'Product_Public';
  description?: Maybe<Scalars['String']['output']>;
  descriptionAr?: Maybe<Scalars['String']['output']>;
  hasProductOptions?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  nameAr: Scalars['String']['output'];
  optionCategories?: Maybe<Array<ProductOptionCategory>>;
  outOfStock: Scalars['Boolean']['output'];
  price: Scalars['Float']['output'];
  priceAfterDiscount?: Maybe<Scalars['Float']['output']>;
  /** Catalog price after the largest flash-sale discountRate defined on the store plan */
  priceAfterFlashSaleDiscount?: Maybe<Scalars['Float']['output']>;
  priceAfterGroupOrderDiscount?: Maybe<Scalars['Float']['output']>;
};

export type PromoCode = {
  __typename?: 'PromoCode';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  discountType: PromoCodeDiscountType;
  discountValue: Scalars['Float']['output'];
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Float']['output'];
  isActive: Scalars['Boolean']['output'];
  maxDiscountAmount?: Maybe<Scalars['Float']['output']>;
  minCartAmount?: Maybe<Scalars['Float']['output']>;
  perUserLimit?: Maybe<Scalars['Int']['output']>;
  redemptions?: Maybe<Array<PromoCodeRedemption>>;
  startsAt?: Maybe<Scalars['DateTime']['output']>;
  store?: Maybe<Store>;
  storeId?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  usageCount: Scalars['Int']['output'];
  usageLimit?: Maybe<Scalars['Int']['output']>;
};

/** Determines whether the promo discount is a percentage of the cart subtotal or a fixed amount */
export enum PromoCodeDiscountType {
  Fixed = 'FIXED',
  Percentage = 'PERCENTAGE'
}

export type PromoCodeRedemption = {
  __typename?: 'PromoCodeRedemption';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  orderId?: Maybe<Scalars['Int']['output']>;
  promoCode: PromoCode;
  updatedAt: Scalars['DateTime']['output'];
  usedAt: Scalars['DateTime']['output'];
  userId: Scalars['Int']['output'];
};

export type Query = {
  __typename?: 'Query';
  /** Active fulfillments across Robinfood drivers and Mr Mandoob. Filter by fleet and mapped requestStatus. */
  activeFulfillments: PaginatedFulfillmentRequests;
  /** ADMIN ONLY: View full order details with nearby drivers ordered by distance from the store. */
  adminGetOrderView?: Maybe<AdminOrderViewDto>;
  /** ADMIN ONLY: List orders that do not have an assigned driver, with filters and pagination. */
  adminGetUnassignedOrders: PaginatedOrdersResponse;
  allBeneficiaries: PaginatedBeneficiariesResponse;
  /** Get all drivers with id and name only (admin only) */
  allDriversList: Array<DriverListItem>;
  /** Get all withdrawals with filtering and pagination (admin only) */
  allWithdrawals: PaginatedWithdrawalsResponse;
  beneficiary?: Maybe<Beneficiary>;
  /** Get car types lookup values */
  carTypesLookup: TawseelLookupResponse;
  /** Get cities lookup values for a given region. */
  citiesLookup: TawseelLookupResponse;
  /** Download ledger transactions as Excel file with partner balances and transactions */
  downloadLedgerTransactions: DownloadLedgerTransactionsResponse;
  driverPerformance: Array<DriverPeriodStatisticsType>;
  /** Get driver profile with driver info and all driver documents */
  driverProfile?: Maybe<User>;
  driverStats: DriverStatsType;
  getActiveAddress: Address;
  /** Get all active countries for nationality dropdown */
  getActiveCountries: Array<Country>;
  getActiveOrdersForPartner: PaginatedPartnerOrdersResponse;
  getAddress: Address;
  getAllAddressesForUser: Array<Address>;
  getAllAddressesForUserWithDeliveryArea: Array<AddressWithDeliveryArea>;
  /** Get all users that have the driver role with filtering and pagination */
  getAllDrivers: PaginatedDriversResponse;
  /** Get all finance tree items (flat list) */
  getAllFinanceTreeItems: Array<FinanceTree>;
  /** Get all finance tree items as flat list with level information and balance (easier for frontend) */
  getAllFinanceTreeItemsWithLevel: Array<FinanceTreeWithLevel>;
  /** Get all finance tree transaction lines with pagination and filters. When financeTreeId is provided, includes all transaction lines for that account and all its sub-accounts (descendants). */
  getAllFinanceTreeTransactionLines: FinanceTreeTransactionLineResponse;
  /** Get all finance tree transactions with pagination and filters */
  getAllFinanceTreeTransactions: FinanceTreeTransactionResponse;
  /** Get all media files */
  getAllMedia: Array<Media>;
  getAllOrders: Array<Order>;
  getAllOrdersForPartner: Array<Order>;
  getAllOrdersForUser: Array<Order>;
  getAllPartnerCategories: Array<PartnerCategory>;
  getAllPartners: Array<Partner>;
  /** Get balance for all partners with optional filtering by date and store (Admin only) */
  getAllPartnersBalance: AllPartnersBalanceResponse;
  getAllPartnersTable: PaginatedPartnersResponse;
  getAllPermissions: Array<Permission>;
  getAllPlans: Array<Plan>;
  getAllProductCategoriesForPartner: Array<ProductCategory>;
  getAllProductOptionCategoriesForPartner: Array<ProductOptionCategory>;
  getAllProducts: Array<Product>;
  getAllProductsForPartner: Array<Product>;
  getAllPromoCodes: Array<PromoCode>;
  getAllStores: Array<Store>;
  getAllStoresForPartner: Array<Store>;
  getAllUsers: Array<User>;
  getAllUsersForPartner: Array<User>;
  getAllWorkingHoursForPartner: Array<WorkingHours>;
  /** Get all customer users (excludes admin and partner users) */
  getCustomerUsers: Array<User>;
  getDeliverySettings?: Maybe<DeliverySetting>;
  /** Get a specific driver by userId with driver info and all driver documents */
  getDriverById?: Maybe<User>;
  /** Get drivers within the provided radius (default 5km) from the store coordinates */
  getDriversNearStore: Array<NearbyDriver>;
  /** Get complete finance tree hierarchy with all nested levels */
  getFinanceTreeHierarchy: Array<FinanceTree>;
  /** Get a single finance tree item by ID */
  getFinanceTreeItem: FinanceTree;
  /** Get a finance tree item with all its descendants */
  getFinanceTreeItemWithDescendants: FinanceTree;
  /** Get a single finance tree transaction by ID */
  getFinanceTreeTransaction: FinanceTreeTransaction;
  /** Get a single finance tree transaction line by ID */
  getFinanceTreeTransactionLine: FinanceTreeTransactionLine;
  /** Get all transaction lines for a specific finance tree account (includes all sub-accounts/descendants) */
  getFinanceTreeTransactionLinesByAccount: Array<FinanceTreeTransactionLine>;
  /** Get all transaction lines for a specific transaction */
  getFinanceTreeTransactionLinesByTransaction: Array<FinanceTreeTransactionLine>;
  /** Get all transactions for a specific finance tree account */
  getFinanceTreeTransactionsByAccount: Array<FinanceTreeTransaction>;
  /** Get finance tree transactions within a date range */
  getFinanceTreeTransactionsByDateRange: Array<FinanceTreeTransaction>;
  getGoogleMapsRushHours?: Maybe<GoogleMapsRushHours>;
  /** Get media file by ID */
  getMediaById: Media;
  /** Get media files by type */
  getMediaByType: Array<Media>;
  getMyActiveRequest?: Maybe<DeliveryOrderSubscriptionData>;
  getMyCart: Cart;
  /** Get my vehicle registration */
  getMyDriverVehicleRegistration?: Maybe<DriverVehicleRegistration>;
  getMySession: ShoppingSession;
  /** Get the current status for the authenticated driver (available/busy/offline) */
  getMyStatus?: Maybe<DriverStatus>;
  getMyUser: User;
  getNearbyFlashSales: Array<FlashSale_Public>;
  getNearbyFlashSalesV2: Array<FlashSale_Public>;
  getNearbyFlashSalesV3: PaginatedFlashSalesResponse;
  getNearbyFlashSalesV4: PaginatedFlashSalesResponse;
  getNearbyStores: Array<Store_Public>;
  getNearbyStoresV2: PaginatedStoresResponse;
  getNearbyStoresV3: PaginatedStoresResponse;
  getNewOrdersForPartner: PaginatedPartnerOrdersResponse;
  getOrderDetailsForUser?: Maybe<OrderWithGroupedItems>;
  getOrderForPartner: OrderWithFinancialDetails;
  getOrderHistoryForPartner: PaginatedPartnerOrdersResponse;
  /** Get order statistics for a date range */
  getOrderStatistics: OrderStatisticsResponse;
  getPaginatedOrdersForUser: PaginatedOrdersResponse;
  getPartner: Partner;
  /** Get balance for authenticated partner with optional store filtering */
  getPartnerBalance: BalanceResponse;
  getPartnerCategory: PartnerCategory;
  getPartnerPromoTracking: PartnerPromoTracking;
  /** Get partner statistics for a date range */
  getPartnerStatistics: PartnerStatisticsResponse;
  /** Get all stores belonging to a specific partner (Admin only) */
  getPartnerStores: Array<Store>;
  getPaymentStatus: Payment;
  getPaymentsBySessionId: Array<Payment>;
  getPendingInvitationsByPartner: Array<Invitation>;
  getPendingInvitationsForPartner: Array<Invitation>;
  getPermission: Permission;
  getPlan: Plan;
  getPlanByStoreId?: Maybe<Plan>;
  getProduct: Product;
  getProductCategory: ProductCategory;
  getProductOptionCategory: ProductOptionCategory;
  getProductOptions: Product_Public;
  getProductsByCategory: Array<ProductCategory_Public>;
  getPromoCode: PromoCode;
  getPublicPartnerCategories: Array<PartnerCategory>;
  /** Sum of POSTED driver transactions for all orders on this request */
  getRequestBalance: Scalars['String']['output'];
  getRoleFucntions: Array<RoleFunctions>;
  /** Get all Saudi banks with codes and names (English and Arabic) */
  getSaudiBanks: Array<BankResponse>;
  getSession: ShoppingSession;
  /** Get signed URL for private file access */
  getSignedUrl: Scalars['String']['output'];
  getStore: Store;
  getStoreConversations: StoreConversationsResponse;
  getSystemConfiguration?: Maybe<SystemConfiguration>;
  getWorkingHours: WorkingHours;
  healthcheck: Scalars['String']['output'];
  /** Get identity types lookup values */
  identityTypesLookup: TawseelLookupResponse;
  isValidToken: Scalars['Boolean']['output'];
  ledgerTransactions: LedgerTransactionsPage;
  maintenanceStatus: MaintenanceStatus;
  myBeneficiaries: Array<Beneficiary>;
  myDeviceTokens: Array<DeviceToken>;
  /** Calendar-period earnings (Asia/Riyadh): deliveryFee, penalty, other (tips), and total */
  myDriverEarnings: Array<DriverPeriodEarningsType>;
  myDriverOrderRequests: PaginatedDeliveryOrdersResponse;
  myDriverRequestCounts: DriverRequestCountsType;
  myDriverStats: DriverStatsType;
  myOrderDetails: Order;
  myOrders: Array<Order>;
  /** Get all active saved cards for the current user */
  mySavedCards: Array<UserSavedCard>;
  /** Get all withdrawal requests for the authenticated driver with filtering and pagination */
  myWithdrawals: PaginatedWithdrawalsResponse;
  nafathVerification: NafathVerification;
  orderDriverRequests: Array<DriverOrderRequest>;
  /** Assignment timeline for one order. Own-driver requests plus the current Mr Mandoob row when deliveryFleet is MR_MANDOOB. */
  orderFulfillmentRequests: Array<FulfillmentRequest>;
  profile: User;
  /** Get regions lookup values. */
  regionsLookup: TawseelLookupResponse;
  /** TEST ONLY: Disabled in production. Get only ACTIVE drivers and their distance (km) from the given coordinate using Redis GEO, no auth/roles. */
  testActiveDriversByCoordinate: Array<NearbyDriver>;
  /** TEST ONLY: Disabled in production. Get drivers and their distance (km) from the given coordinate using Redis GEO, no auth/roles. */
  testDriversByCoordinate: Array<NearbyDriver>;
  /** TEST ONLY: Disabled in production. Get driving distance (km) between customer and order coordinates, no auth/roles. */
  testDrivingDistanceKm: Scalars['Float']['output'];
  /** TEST ONLY (ADMIN): Disabled in production. Get Mr Mandoob order status (GET /api/external/v1/get-order-status). */
  testMrMandoobGetOrderStatus: MrMandoobOrderStatusResultModel;
  /** TEST ONLY: Disabled in production. Trigger sendNewOrderNotificationToNearbyDrivers for a given orderId and optional radiusKm, no auth/roles. */
  testSendNewOrderNotificationToNearbyDrivers?: Maybe<Order>;
  /** Test query that delays execution for timeout testing */
  testTimeout: Scalars['String']['output'];
  transactionCategories: Array<TransactionCategory>;
  transactionCategory: TransactionCategory;
  validateToken: Scalars['String']['output'];
};


export type QueryActiveFulfillmentsArgs = {
  filter?: InputMaybe<ActiveFulfillmentFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryAdminGetOrderViewArgs = {
  orderId: Scalars['Int']['input'];
  radiusKm?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryAdminGetUnassignedOrdersArgs = {
  filter?: InputMaybe<AdminUnassignedOrdersFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryAllBeneficiariesArgs = {
  filter?: InputMaybe<BeneficiaryFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryAllWithdrawalsArgs = {
  filter?: InputMaybe<WithdrawalFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryBeneficiaryArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCitiesLookupArgs = {
  regionId: Scalars['String']['input'];
};


export type QueryDownloadLedgerTransactionsArgs = {
  filter?: InputMaybe<LedgerTransactionsFilter>;
  sort?: InputMaybe<SortInput>;
};


export type QueryDriverStatsArgs = {
  driverId: Scalars['Int']['input'];
};


export type QueryGetActiveOrdersForPartnerArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchOrderDto?: InputMaybe<SearchOrderDto>;
};


export type QueryGetAddressArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGetAllAddressesForUserWithDeliveryAreaArgs = {
  cartId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetAllDriversArgs = {
  filter?: InputMaybe<DriverFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetAllFinanceTreeTransactionLinesArgs = {
  filter?: InputMaybe<FinanceTreeTransactionLineFilterDto>;
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
};


export type QueryGetAllFinanceTreeTransactionsArgs = {
  filter?: InputMaybe<FinanceTreeTransactionFilterDto>;
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
};


export type QueryGetAllOrdersForPartnerArgs = {
  searchOrderDto?: InputMaybe<SearchOrderDto>;
};


export type QueryGetAllPartnersBalanceArgs = {
  filter?: InputMaybe<GetAllPartnersBalanceFilterDto>;
};


export type QueryGetAllPartnersTableArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetDriverByIdArgs = {
  userId: Scalars['Int']['input'];
};


export type QueryGetDriversNearStoreArgs = {
  radiusKm?: InputMaybe<Scalars['Float']['input']>;
  storeId: Scalars['Int']['input'];
};


export type QueryGetFinanceTreeItemArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGetFinanceTreeItemWithDescendantsArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGetFinanceTreeTransactionArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGetFinanceTreeTransactionLineArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGetFinanceTreeTransactionLinesByAccountArgs = {
  financeTreeId: Scalars['Int']['input'];
};


export type QueryGetFinanceTreeTransactionLinesByTransactionArgs = {
  transactionId: Scalars['Int']['input'];
};


export type QueryGetFinanceTreeTransactionsByAccountArgs = {
  financeTreeId: Scalars['Int']['input'];
};


export type QueryGetFinanceTreeTransactionsByDateRangeArgs = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};


export type QueryGetMediaByIdArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGetMediaByTypeArgs = {
  type: MediaType;
};


export type QueryGetNearbyFlashSalesArgs = {
  coordinate: CoordinateArgs;
  searchStoresDto?: InputMaybe<SearchStoreDto>;
};


export type QueryGetNearbyFlashSalesV2Args = {
  coordinate: CoordinateArgs;
  searchStoresDto?: InputMaybe<SearchStoreDto>;
};


export type QueryGetNearbyFlashSalesV3Args = {
  coordinate: CoordinateArgs;
  page?: InputMaybe<Scalars['Float']['input']>;
  perPage?: InputMaybe<Scalars['Float']['input']>;
  searchStoresDto?: InputMaybe<SearchStoreDto>;
};


export type QueryGetNearbyFlashSalesV4Args = {
  coordinate?: InputMaybe<CoordinateArgs>;
  page?: InputMaybe<Scalars['Float']['input']>;
  perPage?: InputMaybe<Scalars['Float']['input']>;
  searchStoresDto?: InputMaybe<SearchStoreDto>;
};


export type QueryGetNearbyStoresArgs = {
  coordinate: CoordinateArgs;
  searchStoresDto?: InputMaybe<SearchStoreDto>;
};


export type QueryGetNearbyStoresV2Args = {
  all?: Scalars['Boolean']['input'];
  coordinate: CoordinateArgs;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  searchStoresDto?: InputMaybe<SearchStoreDto>;
};


export type QueryGetNearbyStoresV3Args = {
  coordinate: CoordinateArgs;
  page?: Scalars['Int']['input'];
  searchStoresDto?: InputMaybe<SearchStoreDto>;
};


export type QueryGetNewOrdersForPartnerArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchOrderDto?: InputMaybe<SearchOrderDto>;
};


export type QueryGetOrderDetailsForUserArgs = {
  orderId: Scalars['Int']['input'];
};


export type QueryGetOrderForPartnerArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGetOrderHistoryForPartnerArgs = {
  pagination?: InputMaybe<PaginationInput>;
  searchOrderDto?: InputMaybe<SearchOrderDto>;
};


export type QueryGetOrderStatisticsArgs = {
  input: GetOrderStatisticsInput;
};


export type QueryGetPaginatedOrdersForUserArgs = {
  filter?: InputMaybe<OrderFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGetPartnerArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetPartnerBalanceArgs = {
  filter?: InputMaybe<GetBalanceFilterDto>;
};


export type QueryGetPartnerCategoryArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGetPartnerPromoTrackingArgs = {
  partnerId: Scalars['Int']['input'];
};


export type QueryGetPartnerStatisticsArgs = {
  input: GetPartnerStatisticsInput;
};


export type QueryGetPartnerStoresArgs = {
  partnerId: Scalars['Int']['input'];
};


export type QueryGetPaymentStatusArgs = {
  ref: Scalars['String']['input'];
};


export type QueryGetPaymentsBySessionIdArgs = {
  sessionId: Scalars['Int']['input'];
};


export type QueryGetPendingInvitationsByPartnerArgs = {
  partnerId: Scalars['Int']['input'];
};


export type QueryGetPermissionArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGetPlanArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGetPlanByStoreIdArgs = {
  storeId: Scalars['Int']['input'];
};


export type QueryGetProductArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGetProductCategoryArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGetProductOptionCategoryArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGetProductOptionsArgs = {
  productId: Scalars['Float']['input'];
};


export type QueryGetProductsByCategoryArgs = {
  storeId: Scalars['Int']['input'];
};


export type QueryGetPromoCodeArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGetRequestBalanceArgs = {
  requestId: Scalars['Int']['input'];
};


export type QueryGetSessionArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetSignedUrlArgs = {
  expiresIn?: Scalars['Float']['input'];
  id: Scalars['Int']['input'];
};


export type QueryGetStoreArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGetStoreConversationsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  storeId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetWorkingHoursArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLedgerTransactionsArgs = {
  filter?: InputMaybe<LedgerTransactionsFilter>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<SortInput>;
};


export type QueryMyDriverOrderRequestsArgs = {
  filter?: InputMaybe<DriverOrderFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryMyOrderDetailsArgs = {
  orderId: Scalars['Int']['input'];
};


export type QueryMyOrdersArgs = {
  status?: InputMaybe<OrderStatus>;
};


export type QueryMyWithdrawalsArgs = {
  filter?: InputMaybe<DriverWithdrawalFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryNafathVerificationArgs = {
  input: GetNafathStatusDto;
};


export type QueryOrderDriverRequestsArgs = {
  orderId: Scalars['Int']['input'];
};


export type QueryOrderFulfillmentRequestsArgs = {
  orderId: Scalars['Int']['input'];
};


export type QueryTestActiveDriversByCoordinateArgs = {
  coordinates: CoordinateArgs;
  radiusKm?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryTestDriversByCoordinateArgs = {
  coordinates: CoordinateArgs;
  radiusKm?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryTestDrivingDistanceKmArgs = {
  customerCoordinates: CoordinateArgs;
  orderCoordinates: CoordinateArgs;
};


export type QueryTestMrMandoobGetOrderStatusArgs = {
  orderId: Scalars['Int']['input'];
};


export type QueryTestSendNewOrderNotificationToNearbyDriversArgs = {
  orderId: Scalars['Int']['input'];
  radiusKm?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryTestTimeoutArgs = {
  delaySeconds?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTransactionCategoryArgs = {
  id: Scalars['ID']['input'];
};

export type RefreshResponse = {
  __typename?: 'RefreshResponse';
  accessToken: Scalars['String']['output'];
  expiresIn: Scalars['Float']['output'];
  refreshToken: Scalars['String']['output'];
  tokenType: Scalars['String']['output'];
};

export type RegisterDeliveryDto = {
  otp: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type RegisterDeviceTokenInput = {
  /** Which app is registering the token. Defaults to customer when omitted. */
  appType?: InputMaybe<DeviceTokenAppType>;
  appVersion?: InputMaybe<Scalars['String']['input']>;
  deviceId?: InputMaybe<Scalars['String']['input']>;
  deviceModel?: InputMaybe<Scalars['String']['input']>;
  deviceName?: InputMaybe<Scalars['String']['input']>;
  osVersion?: InputMaybe<Scalars['String']['input']>;
  platform: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type ReturnMrMandoobOrderDto = {
  orderId: Scalars['Int']['input'];
  reasonOfCancel: Scalars['String']['input'];
};

export type RoleFunctions = {
  __typename?: 'RoleFunctions';
  functions: Array<Scalars['String']['output']>;
  role: Scalars['String']['output'];
};

export type SaveDeliverySettingDto = {
  costPerExtraOrderFreelancerDriver?: InputMaybe<Scalars['Float']['input']>;
  costPerExtraOrderFullTimeDriver?: InputMaybe<Scalars['Float']['input']>;
  costPerOrderFreelancerDriver?: InputMaybe<Scalars['Float']['input']>;
  costPerOrderFullTimeDriver?: InputMaybe<Scalars['Float']['input']>;
  salaryFixedCost?: InputMaybe<Scalars['Float']['input']>;
};

export type SaveGoogleMapsRushHourRuleDto = {
  /** Optional KSA date (YYYY-MM-DD). Null means default. */
  date?: InputMaybe<Scalars['String']['input']>;
  /** Margin in minutes. */
  marginMinutes: Scalars['Float']['input'];
  /** Start time (HH:mm, 24h) in KSA. */
  timeFrom: Scalars['String']['input'];
  /** End time (HH:mm, 24h) in KSA. */
  timeTo: Scalars['String']['input'];
};

export type SaveGoogleMapsRushHoursDto = {
  rules: Array<SaveGoogleMapsRushHourRuleDto>;
};

export type SaveSystemConfigurationDto = {
  batchingBuffer?: InputMaybe<Scalars['Float']['input']>;
  batchingTimeForScheduled?: InputMaybe<Scalars['Float']['input']>;
  batchingTimeForSmart?: InputMaybe<Scalars['Float']['input']>;
  deliveryMargin?: InputMaybe<Scalars['Float']['input']>;
  orderSafetyMargin?: InputMaybe<Scalars['Float']['input']>;
};

export type ScheduledIndividualOrderDiscount = {
  __typename?: 'ScheduledIndividualOrderDiscount';
  createdAt: Scalars['DateTime']['output'];
  discountRate: Scalars['Float']['output'];
  id: Scalars['Float']['output'];
  maxDiscountAmount?: Maybe<Scalars['Float']['output']>;
  minimumCartAmount: Scalars['Float']['output'];
  partnerCoverageRate: Scalars['Float']['output'];
  partnerCoverageType: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ScheduledIndividualOrderDiscountDto = {
  discountRate: Scalars['Float']['input'];
  maxDiscountAmount?: InputMaybe<Scalars['Float']['input']>;
  minimumCartAmount: Scalars['Float']['input'];
  partnerCoverageRate: Scalars['Float']['input'];
  partnerCoverageType: PartnerCoverageType;
};

/** The scheduling type of shopping session (urgent, normal, scheduled) */
export enum ScheduledType {
  Normal = 'NORMAL',
  Scheduled = 'SCHEDULED',
  Urgent = 'URGENT'
}

export type SearchOrderDto = {
  createdAfter?: InputMaybe<Scalars['DateTime']['input']>;
  createdBefore?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<OrderStatus>;
  storeId?: InputMaybe<Scalars['Int']['input']>;
};

export type SearchStoreDto = {
  escapeDuration?: InputMaybe<Scalars['Boolean']['input']>;
  partnerCategoryId?: InputMaybe<Scalars['Int']['input']>;
  partnerCategoryName?: InputMaybe<Scalars['String']['input']>;
  partnerName?: InputMaybe<Scalars['String']['input']>;
  storeId?: InputMaybe<Scalars['Int']['input']>;
  storeName?: InputMaybe<Scalars['String']['input']>;
};

export type SendDeliveryOtpDto = {
  phoneNumber: Scalars['String']['input'];
};

export type SendHelloMessageInput = {
  fcmToken: Scalars['String']['input'];
};

export type SendMultipleNotificationsInput = {
  body: Scalars['String']['input'];
  data?: InputMaybe<Scalars['JSONObject']['input']>;
  deviceTokens: Array<Scalars['String']['input']>;
  imageId?: InputMaybe<Scalars['Int']['input']>;
  title: Scalars['String']['input'];
};

export type SendNotificationInput = {
  body: Scalars['String']['input'];
  data?: InputMaybe<Scalars['JSONObject']['input']>;
  deviceToken: Scalars['String']['input'];
  imageId?: InputMaybe<Scalars['Int']['input']>;
  title: Scalars['String']['input'];
};

export type SendNotificationToUserInput = {
  body: LocalizedTextInput;
  data?: InputMaybe<Scalars['JSONObject']['input']>;
  /** Only send to tokens registered for this app (customer / driver / partner). Omit to include all app types. */
  deviceTokenAppType?: InputMaybe<DeviceTokenAppType>;
  imageId?: InputMaybe<Scalars['Int']['input']>;
  title: LocalizedTextInput;
  userIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type SendOtpDto = {
  phoneNumber: Scalars['String']['input'];
};

export type SendTopicNotificationInput = {
  body: Scalars['String']['input'];
  data?: InputMaybe<Scalars['JSONObject']['input']>;
  imageId?: InputMaybe<Scalars['Int']['input']>;
  title: Scalars['String']['input'];
  topic: Scalars['String']['input'];
};

export type SetMaintenanceInput = {
  enabled: Scalars['Boolean']['input'];
};

export type ShoppingSession = {
  __typename?: 'ShoppingSession';
  carts?: Maybe<Array<Cart>>;
  computes: Computes;
  createdAt: Scalars['DateTime']['output'];
  defaultPaymentShareType: Scalars['String']['output'];
  endTime?: Maybe<Scalars['DateTime']['output']>;
  endTimeMinutes?: Maybe<Scalars['Int']['output']>;
  /** Invite link for the session */
  groupLink?: Maybe<Scalars['String']['output']>;
  hostAddress: Address;
  id: Scalars['Float']['output'];
  isAllGuestsReady?: Maybe<Scalars['Boolean']['output']>;
  orders?: Maybe<Array<Order>>;
  payments: Array<Payment>;
  requiredMemberCount: Scalars['Int']['output'];
  scheduledType: Scalars['String']['output'];
  status: Scalars['String']['output'];
  store: Store;
  type: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

/** The type of shopping session/order */
export enum ShoppingSessionType {
  FlashSale = 'FLASH_SALE',
  GroupDelivery = 'GROUP_DELIVERY',
  GroupOrder = 'GROUP_ORDER',
  IndividualOrder = 'INDIVIDUAL_ORDER'
}

export type SortInput = {
  sortBy?: TxSortBy;
  sortOrder?: SortOrder;
};

export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type StatusBreakdown = {
  __typename?: 'StatusBreakdown';
  count: Scalars['Int']['output'];
  percentage: Scalars['Float']['output'];
  status: Scalars['String']['output'];
};

export type Store = {
  __typename?: 'Store';
  address?: Maybe<Scalars['String']['output']>;
  chatwootConversationId?: Maybe<Scalars['String']['output']>;
  chatwootSourceId?: Maybe<Scalars['String']['output']>;
  cityId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  defaultWorkingHours?: Maybe<WorkingHours>;
  id: Scalars['Float']['output'];
  isActive: Scalars['Boolean']['output'];
  isConnected: Scalars['Boolean']['output'];
  isOnline: Scalars['Boolean']['output'];
  isTemporarilyClosed: Scalars['Boolean']['output'];
  lastSeenAt?: Maybe<Scalars['DateTime']['output']>;
  latitude: Scalars['Float']['output'];
  locationImage?: Maybe<Media>;
  longitude: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  nameAr: Scalars['String']['output'];
  orders?: Maybe<Order>;
  partner: Partner;
  phone?: Maybe<Scalars['String']['output']>;
  preparationTime?: Maybe<Scalars['Int']['output']>;
  productStores: Array<ProductStore>;
  products: Array<Product>;
  regionId?: Maybe<Scalars['String']['output']>;
  temporarilyClosedNote?: Maybe<Scalars['String']['output']>;
  temporarilyClosedNoteAr?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  workingHours: Array<WorkingHours>;
};

export type StoreBalance = {
  __typename?: 'StoreBalance';
  /** Total balance as decimal string */
  balance: Scalars['String']['output'];
  storeId: Scalars['Int']['output'];
  storeName: Scalars['String']['output'];
  storeNameAr: Scalars['String']['output'];
};

export type StoreConnectivityStatus = {
  __typename?: 'StoreConnectivityStatus';
  isConnected: Scalars['Boolean']['output'];
  lastSeenAt?: Maybe<Scalars['DateTime']['output']>;
  storeId: Scalars['Int']['output'];
  storeName: Scalars['String']['output'];
  storeNameAr: Scalars['String']['output'];
};

export type StoreConversationsResponse = {
  __typename?: 'StoreConversationsResponse';
  hasMore: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  orders: Array<Order>;
  technicalConversationId?: Maybe<Scalars['String']['output']>;
  total: Scalars['Int']['output'];
};

export type StoreInfo = {
  __typename?: 'StoreInfo';
  ar: Scalars['String']['output'];
  en: Scalars['String']['output'];
};

export type Store_Public = {
  __typename?: 'Store_Public';
  coverImageUrl?: Maybe<Scalars['String']['output']>;
  /** Delivery fee configuration from this store's plan, projected for the nearby stores UI */
  deliveryPlan?: Maybe<NearbyStoreDeliveryPlan>;
  distance: Scalars['Float']['output'];
  duration: Scalars['Int']['output'];
  /** Estimated end-to-end delivery times by order type, plus rush-hour travel durations */
  estimatedDeliveryTime: EstimatedDeliveryTime;
  /** Max discountRate from this store's plan groupOrderDiscounts */
  groupOrderDiscount?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Float']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  isConnected: Scalars['Boolean']['output'];
  isOnline: Scalars['Boolean']['output'];
  isOutOfDeliveryArea: Scalars['Boolean']['output'];
  isTemporarilyClosed: Scalars['Boolean']['output'];
  lookingForCustomerMinutes: Scalars['Int']['output'];
  /** Order safety margin in minutes (from system configuration orderSafetyMargin) */
  orderFinishTimeMinutes: Scalars['Int']['output'];
  partnerCategories?: Maybe<Array<PartnerCategory>>;
  partnerName: Scalars['String']['output'];
  preparationTime?: Maybe<Scalars['Int']['output']>;
  productImageUrl?: Maybe<Scalars['String']['output']>;
  /** Max discountRate from this store's plan scheduledIndividualOrderDiscounts */
  scheduledOrderDiscount?: Maybe<Scalars['Float']['output']>;
  storeName: Scalars['String']['output'];
  storeNameAr: Scalars['String']['output'];
  temporarilyClosedNote?: Maybe<Scalars['String']['output']>;
  temporarilyClosedNoteAr?: Maybe<Scalars['String']['output']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  healthcheck_sub: Scalars['String']['output'];
  /** Subscribe to new delivery orders that are available for the authenticated driver */
  newDeliveryOrder?: Maybe<DeliveryOrderSubscriptionData>;
  orderCreated?: Maybe<OrderWithGroupedItems>;
  orderDriverLocationUpdated?: Maybe<OrderDriverLocationUpdate>;
  orderUpdated?: Maybe<OrderWithGroupedItems>;
  paymentCreated: Payment;
  paymentUpdated: Payment;
  shoppingSessionUpdated: ShoppingSession;
  storeConnectivityChanged: StoreConnectivityStatus;
  storeCreated: Store;
  storeUpdated: Store;
};


export type SubscriptionOrderCreatedArgs = {
  storeId?: InputMaybe<Scalars['Int']['input']>;
};


export type SubscriptionOrderDriverLocationUpdatedArgs = {
  orderId: Scalars['Int']['input'];
};


export type SubscriptionOrderUpdatedArgs = {
  storeId?: InputMaybe<Scalars['Int']['input']>;
};


export type SubscriptionShoppingSessionUpdatedArgs = {
  sessionId: Scalars['Int']['input'];
};

export type SystemConfiguration = {
  __typename?: 'SystemConfiguration';
  /** Batching buffer, in minutes */
  batchingBuffer: Scalars['Float']['output'];
  /** Batching time for scheduled orders, in minutes */
  batchingTimeForScheduled: Scalars['Float']['output'];
  /** Batching time for smart orders, in minutes */
  batchingTimeForSmart: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** Delivery margin, in minutes */
  deliveryMargin: Scalars['Float']['output'];
  id: Scalars['Float']['output'];
  /** Order safety margin, in minutes */
  orderSafetyMargin: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type TawseelDriverTripSimulationResult = {
  __typename?: 'TawseelDriverTripSimulationResult';
  /** Driver body sent to Logisti createDriver. */
  driver: TawseelSimulatedDriver;
  /** Logisti driver refrenceCode. */
  driverReferenceCode?: Maybe<Scalars['String']['output']>;
  /** Order body sent to Logisti createOrder after the driver is accepted. */
  order?: Maybe<TawseelSimulatedOrder>;
  /** Execute-order body sent after the driver is assigned. paymentMethodId stays fixed. */
  orderExecution?: Maybe<TawseelSimulatedOrderExecution>;
  /** Logisti order referenceCode. */
  orderReferenceCode?: Maybe<Scalars['String']['output']>;
  steps: Array<TawseelDriverTripSimulationStep>;
  success: Scalars['Boolean']['output'];
};

export type TawseelDriverTripSimulationStep = {
  __typename?: 'TawseelDriverTripSimulationStep';
  /** Logisti errorCodes from the integration guide appendix. */
  errorCodes: Array<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** Raw Logisti response for this step. */
  response?: Maybe<Scalars['JSON']['output']>;
  success: Scalars['Boolean']['output'];
};

export type TawseelLookupItemType = {
  __typename?: 'TawseelLookupItemType';
  id: Scalars['String']['output'];
  nameAr: Scalars['String']['output'];
  nameEn: Scalars['String']['output'];
};

export type TawseelLookupResponse = {
  __typename?: 'TawseelLookupResponse';
  data: Array<TawseelLookupItemType>;
  errorCodes?: Maybe<Array<Scalars['Int']['output']>>;
  status: Scalars['Boolean']['output'];
};

export type TawseelQueuedResponse = {
  __typename?: 'TawseelQueuedResponse';
  message: Scalars['String']['output'];
  queued: Scalars['Boolean']['output'];
  success: Scalars['Boolean']['output'];
};

export type TawseelSimulatedDriver = {
  __typename?: 'TawseelSimulatedDriver';
  cityId: Scalars['String']['output'];
  /** Hijri date of birth, YYYYMMDD. */
  dateOfBirth: Scalars['String']['output'];
  /** Saudi national ID. Starts with 1 and changes on every call. */
  idNumber: Scalars['String']['output'];
  /** National identity type. Fixed for every simulated driver. */
  identityTypeId: Scalars['String']['output'];
  /** Mobile number, 10 digits starting with 05. */
  mobile: Scalars['String']['output'];
  regionId: Scalars['String']['output'];
  registrationDate: Scalars['String']['output'];
  /** Saudi vehicle sequence number, 9 digits. */
  vehicleSequenceNumber: Scalars['String']['output'];
};

export type TawseelSimulatedOrder = {
  __typename?: 'TawseelSimulatedOrder';
  authorityId: Scalars['String']['output'];
  categoryId: Scalars['String']['output'];
  cityId: Scalars['String']['output'];
  /** Delivery coordinates inside Makkah, "lat, lng". */
  coordinates: Scalars['String']['output'];
  deliveryTime: Scalars['String']['output'];
  orderDate: Scalars['String']['output'];
  /** Robin-food prefix plus a unique number. */
  orderNumber: Scalars['String']['output'];
  /** Recipient mobile, 9665 followed by 8 digits. */
  recipientMobileNumber: Scalars['String']['output'];
  regionId: Scalars['String']['output'];
  /** Store coordinates inside Makkah, "lat, lng". */
  storeLocation: Scalars['String']['output'];
  /** Generated store name, at most 180 characters. */
  storeName: Scalars['String']['output'];
};

export type TawseelSimulatedOrderExecution = {
  __typename?: 'TawseelSimulatedOrderExecution';
  deliveryPrice: Scalars['Float']['output'];
  driverIncome: Scalars['Float']['output'];
  executionTime: Scalars['String']['output'];
  paymentMethodId: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  priceWithoutDelivery: Scalars['Float']['output'];
  referenceCode: Scalars['String']['output'];
};

export type TawseelTestResponse = {
  __typename?: 'TawseelTestResponse';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

/** Accept or reject the simulated order after it is created. */
export enum TawseelTripOrderDecision {
  Accept = 'ACCEPT',
  Reject = 'REJECT'
}

export type TopPartner = {
  __typename?: 'TopPartner';
  deliveryCount: Scalars['Int']['output'];
  partnerId: Scalars['Int']['output'];
  partnerName: Scalars['String']['output'];
  totalDeliveryFees: Scalars['Float']['output'];
  totalTips: Scalars['Float']['output'];
};

export type TopStore = {
  __typename?: 'TopStore';
  averageOrderValue: Scalars['Float']['output'];
  orderCount: Scalars['Int']['output'];
  storeId: Scalars['Int']['output'];
  storeName: Scalars['String']['output'];
  storeNameAr: Scalars['String']['output'];
  totalRevenue: Scalars['Float']['output'];
};

export type TopicManagementResponse = {
  __typename?: 'TopicManagementResponse';
  failureCount: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  successCount: Scalars['Int']['output'];
};

export type TotalTrip_Public = {
  __typename?: 'TotalTrip_Public';
  foodQualityTimeMinutes: Scalars['Int']['output'];
  hostToMember?: Maybe<TripLeg_Public>;
  hostToStore?: Maybe<TripLeg_Public>;
};

export type TransactionCategory = {
  __typename?: 'TransactionCategory';
  children: Array<TransactionCategory>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  isEditable: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  nameAr?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<TransactionCategory>;
  slug: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum TransactionStatus {
  Pending = 'PENDING',
  Posted = 'POSTED',
  Voided = 'VOIDED'
}

export enum TransactionType {
  AdditionalCustomerFee = 'ADDITIONAL_CUSTOMER_FEE',
  Adjustment = 'ADJUSTMENT',
  DeliveryFee = 'DELIVERY_FEE',
  DiscountPartnerCoverage = 'DISCOUNT_PARTNER_COVERAGE',
  DistanceFee = 'DISTANCE_FEE',
  FastDeliveryFee = 'FAST_DELIVERY_FEE',
  GatewayFee = 'GATEWAY_FEE',
  OrderCapture = 'ORDER_CAPTURE',
  PartnerDeliveryCoverage = 'PARTNER_DELIVERY_COVERAGE',
  Payout = 'PAYOUT',
  PlatformCommission = 'PLATFORM_COMMISSION',
  Refund = 'REFUND',
  Tip = 'TIP'
}

export type TripLeg_Public = {
  __typename?: 'TripLeg_Public';
  distance: Scalars['Float']['output'];
  duration: Scalars['Int']['output'];
};

export enum TxSortBy {
  Amount = 'AMOUNT',
  AvailableAt = 'AVAILABLE_AT',
  CreatedAt = 'CREATED_AT',
  PostedAt = 'POSTED_AT'
}

export enum UpdatableShoppingSessionStatus {
  InitiatedCheckout = 'INITIATED_CHECKOUT',
  InProgress = 'IN_PROGRESS'
}

export type UpdateAddressDto = {
  addressCategory?: InputMaybe<Address_Category>;
  addressCategoryLabel?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<Scalars['String']['input']>;
  fullAddress?: InputMaybe<Scalars['String']['input']>;
  fullAddressAr?: InputMaybe<Scalars['String']['input']>;
  isTemp?: InputMaybe<Scalars['Boolean']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameAr?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBeneficiaryDto = {
  bankCode?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  ibanPhotoId?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBeneficiaryStatusDto = {
  id: Scalars['Int']['input'];
  status: BeneficiaryStatus;
};

export type UpdateCartDto = {
  addressId?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isHost?: InputMaybe<Scalars['Boolean']['input']>;
  isReady?: InputMaybe<Scalars['Boolean']['input']>;
  paymentShareType?: InputMaybe<Scalars['String']['input']>;
  paymentValue?: InputMaybe<Scalars['Float']['input']>;
  scheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
  shoppingSessionId?: InputMaybe<Scalars['Int']['input']>;
  storeId?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateChatwootDriverConversationDto = {
  conversationId: Scalars['String']['input'];
  orderId: Scalars['Int']['input'];
};

export type UpdateDriverDocumentStatusDto = {
  documentType: Driver_Document_Type;
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
  status: Driver_Registration_Status;
};

export type UpdateDriverOrderRequestStatusDto = {
  driverCoordinates?: InputMaybe<CoordinateArgs>;
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
  requestId: Scalars['Int']['input'];
  status: DriverOrderRequestStatus;
};

export type UpdateDriverOrderRequestStatusResponse = {
  __typename?: 'UpdateDriverOrderRequestStatusResponse';
  message: Scalars['String']['output'];
  request?: Maybe<DriverOrderRequest>;
  success: Scalars['Boolean']['output'];
};

export type UpdateDriverStatusDto = {
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
  status: Driver_Registration_Status;
  userId: Scalars['Int']['input'];
};

export type UpdateFinanceTreeDto = {
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameAr?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFinanceTreeTransactionDto = {
  /** Transaction date (ISO 8601 format) */
  date?: InputMaybe<Scalars['String']['input']>;
  /** Transaction description */
  description?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<CreateMediaDto>;
  /** Transaction lines (replaces all existing lines if provided) */
  transactionLines?: InputMaybe<Array<CreateFinanceTreeTransactionLineDto>>;
};

export type UpdateOrderStatusDto = {
  driverCoordinates?: InputMaybe<CoordinateArgs>;
  mediaId?: InputMaybe<Scalars['Int']['input']>;
  orderId: Scalars['Int']['input'];
  status: OrderStatus;
};

export type UpdatePartnerCategoryDto = {
  media?: InputMaybe<CreateMediaDto>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameAr?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePartnerDto = {
  address?: InputMaybe<Scalars['String']['input']>;
  coverImageId?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  imageId?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameAr?: InputMaybe<Scalars['String']['input']>;
  partnerCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  planId?: InputMaybe<Scalars['Int']['input']>;
  productImageId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdatePermissionDto = {
  functions?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  userIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type UpdatePlanDto = {
  commissionRate?: InputMaybe<Scalars['Int']['input']>;
  deliveryPlan?: InputMaybe<DeliveryPlanDto>;
  flashSaleDiscounts?: InputMaybe<Array<FlashSaleDiscountDto>>;
  groupDeliveryDiscounts?: InputMaybe<Array<GroupDeliveryDiscountDto>>;
  groupOrderDiscounts?: InputMaybe<Array<GroupOrderDiscountDto>>;
  individualOrderDiscounts?: InputMaybe<Array<IndividualOrderDiscountDto>>;
  minCommissionAmount?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  scheduledIndividualOrderDiscounts?: InputMaybe<Array<ScheduledIndividualOrderDiscountDto>>;
  urgentIndividualOrderDiscounts?: InputMaybe<Array<UrgentIndividualOrderDiscountDto>>;
};

export type UpdateProductCategoryDto = {
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionAr?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameAr?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateProductDto = {
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionAr?: InputMaybe<Scalars['String']['input']>;
  /** Food quality time in minutes */
  foodQualityTimeMinutes?: InputMaybe<Scalars['Int']['input']>;
  imageId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameAr?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  productCategoryId?: InputMaybe<Scalars['Int']['input']>;
  productOptionCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  storeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type UpdateProductOptionCategoryDto = {
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionAr?: InputMaybe<Scalars['String']['input']>;
  max?: InputMaybe<Scalars['Int']['input']>;
  min?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameAr?: InputMaybe<Scalars['String']['input']>;
  productOptions?: InputMaybe<Array<ProductOptionDto>>;
};

export type UpdatePromoCodeDto = {
  code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discountType?: InputMaybe<PromoCodeDiscountType>;
  discountValue?: InputMaybe<Scalars['Float']['input']>;
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  maxDiscountAmount?: InputMaybe<Scalars['Float']['input']>;
  minCartAmount?: InputMaybe<Scalars['Float']['input']>;
  perUserLimit?: InputMaybe<Scalars['Int']['input']>;
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
  storeId?: InputMaybe<Scalars['Int']['input']>;
  usageLimit?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateShoppingSessionStatusInput = {
  status: UpdatableShoppingSessionStatus;
};

export type UpdateStoreDto = {
  address?: InputMaybe<Scalars['String']['input']>;
  /** City externalId from Tawseel cities lookup (must be in the selected region) */
  cityId: Scalars['String']['input'];
  defaultWorkingHoursId?: InputMaybe<Scalars['Int']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  locationImageId?: InputMaybe<Scalars['Int']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameAr?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  preparationTime?: InputMaybe<Scalars['Int']['input']>;
  /** Region externalId from Tawseel regions lookup */
  regionId: Scalars['String']['input'];
};

export type UpdateTransactionCategoryInput = {
  id: Scalars['ID']['input'];
  isEditable?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameAr?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserDto = {
  activeAddressId?: InputMaybe<Scalars['Int']['input']>;
  age?: InputMaybe<Scalars['Int']['input']>;
  chatwootCustomerConversationId?: InputMaybe<Scalars['String']['input']>;
  chatwootDriverConversationId?: InputMaybe<Scalars['String']['input']>;
  chatwootPartnerConversationId?: InputMaybe<Scalars['String']['input']>;
  chatwootSourceId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  passwordHash?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<Scalars['String']['input']>>;
  storeId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateUserNameDto = {
  name: Scalars['String']['input'];
};

export type UpdateWithdrawalStatusDto = {
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
  status: WithdrawalStatus;
  withdrawalId: Scalars['Int']['input'];
};

export type UpdateWorkingHoursDto = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Array<CreateWorkingHoursItemDto>>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameAr?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  storeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type UrgentIndividualOrderDiscount = {
  __typename?: 'UrgentIndividualOrderDiscount';
  createdAt: Scalars['DateTime']['output'];
  discountRate: Scalars['Float']['output'];
  id: Scalars['Float']['output'];
  maxDiscountAmount?: Maybe<Scalars['Float']['output']>;
  minimumCartAmount: Scalars['Float']['output'];
  partnerCoverageRate: Scalars['Float']['output'];
  partnerCoverageType: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type UrgentIndividualOrderDiscountDto = {
  discountRate: Scalars['Float']['input'];
  maxDiscountAmount?: InputMaybe<Scalars['Float']['input']>;
  minimumCartAmount: Scalars['Float']['input'];
  partnerCoverageRate: Scalars['Float']['input'];
  partnerCoverageType: PartnerCoverageType;
};

export type User = {
  __typename?: 'User';
  activeAddress?: Maybe<Address>;
  addresses: Array<Address>;
  age?: Maybe<Scalars['Int']['output']>;
  /** Whether the driver has auto-accept for order requests enabled (driver profile only) */
  autoAcceptOrderRequest?: Maybe<Scalars['Boolean']['output']>;
  /** Driver balance - sum of all POSTED driver transactions */
  balance?: Maybe<Scalars['String']['output']>;
  beneficiaries?: Maybe<Array<Beneficiary>>;
  chatwootCustomerConversationId?: Maybe<Scalars['String']['output']>;
  chatwootDriverConversationId?: Maybe<Scalars['String']['output']>;
  chatwootPartnerConversationId?: Maybe<Scalars['String']['output']>;
  chatwootSourceId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  driverIdentity?: Maybe<DriverIdentity>;
  driverInfo?: Maybe<DriverInfo>;
  driverLicense?: Maybe<DriverLicense>;
  driverProfilePicture?: Maybe<DriverProfilePicture>;
  driverVehicleRegistration?: Maybe<DriverVehicleRegistration>;
  email?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  isBypass: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  orders?: Maybe<Order>;
  partner?: Maybe<Partner>;
  partnerName?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Array<Permission>>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  registrationId?: Maybe<Scalars['String']['output']>;
  roles: Array<Scalars['String']['output']>;
  /** Overall driver registration status (same as driverInfo.registrationStatus) */
  status?: Maybe<Driver_Registration_Status>;
  store?: Maybe<Store>;
  storeName?: Maybe<Scalars['String']['output']>;
  /** Driver total revenue today (Asia/Riyadh) - sum of POSTED DELIVERY_FEE, EXTRA_ORDER, and TIP */
  totalRevenueToday?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type UserSavedCard = {
  __typename?: 'UserSavedCard';
  binCountry?: Maybe<Scalars['String']['output']>;
  cardBin?: Maybe<Scalars['String']['output']>;
  cardHolder: Scalars['String']['output'];
  cardType: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  expiryMonth: Scalars['String']['output'];
  expiryYear: Scalars['String']['output'];
  id: Scalars['Float']['output'];
  isActive: Scalars['Boolean']['output'];
  isApplePay: Scalars['Boolean']['output'];
  issuerBank?: Maybe<Scalars['String']['output']>;
  last4Digits: Scalars['String']['output'];
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>;
  paymentBrand: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  userId: Scalars['ID']['output'];
};

export type WithdrawalFilterInput = {
  /** Include withdrawals created on/after this date (YYYY-MM-DD or ISO 8601) */
  createdAfter?: InputMaybe<Scalars['String']['input']>;
  /** Include withdrawals created on/before this date (YYYY-MM-DD or ISO 8601) */
  createdBefore?: InputMaybe<Scalars['String']['input']>;
  driverId?: InputMaybe<Scalars['Int']['input']>;
  /** Filter by beneficiary IBAN (partial or full match) */
  iban?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<WithdrawalStatus>;
  statuses?: InputMaybe<Array<WithdrawalStatus>>;
};

/** Status of a driver withdrawal */
export enum WithdrawalStatus {
  Approved = 'APPROVED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Rejected = 'REJECTED'
}

export type WorkingHours = {
  __typename?: 'WorkingHours';
  createdAt: Scalars['DateTime']['output'];
  endDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  items?: Maybe<Array<WorkingHoursItem>>;
  name: Scalars['String']['output'];
  nameAr: Scalars['String']['output'];
  partner: Partner;
  priority: Scalars['Int']['output'];
  startDate?: Maybe<Scalars['String']['output']>;
  stores?: Maybe<Array<Store>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type WorkingHoursItem = {
  __typename?: 'WorkingHoursItem';
  createdAt: Scalars['DateTime']['output'];
  endTime: Scalars['String']['output'];
  id: Scalars['Float']['output'];
  startTime: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  weekday: Scalars['Int']['output'];
  workingHours: WorkingHours;
};

export type WorkingHoursItem_Public = {
  __typename?: 'WorkingHoursItem_Public';
  endTime: Scalars['String']['output'];
  startTime: Scalars['String']['output'];
  weekday: Scalars['Int']['output'];
  workingHoursId: Scalars['Float']['output'];
};

export type UpsertCartItem = {
  cartId?: InputMaybe<Scalars['Int']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  optionIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  priceId?: InputMaybe<Scalars['Int']['input']>;
  productId: Scalars['Int']['input'];
  quantity: Scalars['Int']['input'];
};
